

import {
  mk_query,
  mk_rel_query,
  RelationBuilder,
  RelationsOf,
  FilterBuilderComplex,
  FilterBuilderBoolean,
  FilterBuilderNumber,
  FilterBuilderString,
  FilterBuilderCollection,
  FilterBuilderDate,
  parseBoolean,
  parseNumber,
  parseString,
  parseDate,
  EntityParser,
  parseCollection,
  parseEntity,
  succes,
  parseNullBoolean,
  parseNullNumber,
  parseNullDate,
  parseNullString,
  OrderByBuilderComplex,
  OrderByProp
} from "typescript-odata-client"
import { List } from "immutable"


const mk_prefix = (id: string, prefix?: string) => prefix ? prefix + '/' + id : id



  export const AdminQuery = (uri?: string) => mk_query<Admin>(
    FilterBuilderAdmin(), 
    AdminRelationBuilder,
    uri != undefined ? uri + 'Admin' : 'http://localhost:5000/odata/Admin',
    AdminParser,
    AdminOrderBy("")
  )

  export const ApplicationQuery = (uri?: string) => mk_query<Application>(
    FilterBuilderApplication(), 
    ApplicationRelationBuilder,
    uri != undefined ? uri + 'Application' : 'http://localhost:5000/odata/Application',
    ApplicationParser,
    ApplicationOrderBy("")
  )

  export const GlobalProductQuery = (uri?: string) => mk_query<GlobalProduct>(
    FilterBuilderGlobalProduct(), 
    GlobalProductRelationBuilder,
    uri != undefined ? uri + 'GlobalProduct' : 'http://localhost:5000/odata/GlobalProduct',
    GlobalProductParser,
    GlobalProductOrderBy("")
  )

  export const GlobalProductManagerQuery = (uri?: string) => mk_query<GlobalProductManager>(
    FilterBuilderGlobalProductManager(), 
    GlobalProductManagerRelationBuilder,
    uri != undefined ? uri + 'GlobalProductManager' : 'http://localhost:5000/odata/GlobalProductManager',
    GlobalProductManagerParser,
    GlobalProductManagerOrderBy("")
  )

  export const GlobalProduct_LocalizedProductHeaderQuery = (uri?: string) => mk_query<GlobalProduct_LocalizedProductHeader>(
    FilterBuilderGlobalProduct_LocalizedProductHeader(), 
    GlobalProduct_LocalizedProductHeaderRelationBuilder,
    uri != undefined ? uri + 'GlobalProduct_LocalizedProductHeader' : 'http://localhost:5000/odata/GlobalProduct_LocalizedProductHeader',
    GlobalProduct_LocalizedProductHeaderParser,
    GlobalProduct_LocalizedProductHeaderOrderBy("")
  )

  export const GlobalProduct_LocalizedPropertyGroupQuery = (uri?: string) => mk_query<GlobalProduct_LocalizedPropertyGroup>(
    FilterBuilderGlobalProduct_LocalizedPropertyGroup(), 
    GlobalProduct_LocalizedPropertyGroupRelationBuilder,
    uri != undefined ? uri + 'GlobalProduct_LocalizedPropertyGroup' : 'http://localhost:5000/odata/GlobalProduct_LocalizedPropertyGroup',
    GlobalProduct_LocalizedPropertyGroupParser,
    GlobalProduct_LocalizedPropertyGroupOrderBy("")
  )

  export const GlobalProduct_PropertyQuery = (uri?: string) => mk_query<GlobalProduct_Property>(
    FilterBuilderGlobalProduct_Property(), 
    GlobalProduct_PropertyRelationBuilder,
    uri != undefined ? uri + 'GlobalProduct_Property' : 'http://localhost:5000/odata/GlobalProduct_Property',
    GlobalProduct_PropertyParser,
    GlobalProduct_PropertyOrderBy("")
  )

  export const GlobalProduct_UnLocalizedProductHeaderQuery = (uri?: string) => mk_query<GlobalProduct_UnLocalizedProductHeader>(
    FilterBuilderGlobalProduct_UnLocalizedProductHeader(), 
    GlobalProduct_UnLocalizedProductHeaderRelationBuilder,
    uri != undefined ? uri + 'GlobalProduct_UnLocalizedProductHeader' : 'http://localhost:5000/odata/GlobalProduct_UnLocalizedProductHeader',
    GlobalProduct_UnLocalizedProductHeaderParser,
    GlobalProduct_UnLocalizedProductHeaderOrderBy("")
  )

  export const LocaleQuery = (uri?: string) => mk_query<Locale>(
    FilterBuilderLocale(), 
    LocaleRelationBuilder,
    uri != undefined ? uri + 'Locale' : 'http://localhost:5000/odata/Locale',
    LocaleParser,
    LocaleOrderBy("")
  )

  export const LocalizedProductHeaderQuery = (uri?: string) => mk_query<LocalizedProductHeader>(
    FilterBuilderLocalizedProductHeader(), 
    LocalizedProductHeaderRelationBuilder,
    uri != undefined ? uri + 'LocalizedProductHeader' : 'http://localhost:5000/odata/LocalizedProductHeader',
    LocalizedProductHeaderParser,
    LocalizedProductHeaderOrderBy("")
  )

  export const LocalizedProductHeader_LocaleQuery = (uri?: string) => mk_query<LocalizedProductHeader_Locale>(
    FilterBuilderLocalizedProductHeader_Locale(), 
    LocalizedProductHeader_LocaleRelationBuilder,
    uri != undefined ? uri + 'LocalizedProductHeader_Locale' : 'http://localhost:5000/odata/LocalizedProductHeader_Locale',
    LocalizedProductHeader_LocaleParser,
    LocalizedProductHeader_LocaleOrderBy("")
  )

  export const LocalizedProductHeader_UspQuery = (uri?: string) => mk_query<LocalizedProductHeader_Usp>(
    FilterBuilderLocalizedProductHeader_Usp(), 
    LocalizedProductHeader_UspRelationBuilder,
    uri != undefined ? uri + 'LocalizedProductHeader_Usp' : 'http://localhost:5000/odata/LocalizedProductHeader_Usp',
    LocalizedProductHeader_UspParser,
    LocalizedProductHeader_UspOrderBy("")
  )

  export const LocalizedPropertyGroupQuery = (uri?: string) => mk_query<LocalizedPropertyGroup>(
    FilterBuilderLocalizedPropertyGroup(), 
    LocalizedPropertyGroupRelationBuilder,
    uri != undefined ? uri + 'LocalizedPropertyGroup' : 'http://localhost:5000/odata/LocalizedPropertyGroup',
    LocalizedPropertyGroupParser,
    LocalizedPropertyGroupOrderBy("")
  )

  export const LocalizedPropertyGroup_LocaleQuery = (uri?: string) => mk_query<LocalizedPropertyGroup_Locale>(
    FilterBuilderLocalizedPropertyGroup_Locale(), 
    LocalizedPropertyGroup_LocaleRelationBuilder,
    uri != undefined ? uri + 'LocalizedPropertyGroup_Locale' : 'http://localhost:5000/odata/LocalizedPropertyGroup_Locale',
    LocalizedPropertyGroup_LocaleParser,
    LocalizedPropertyGroup_LocaleOrderBy("")
  )

  export const LocalizedPropertyGroup_PropertyQuery = (uri?: string) => mk_query<LocalizedPropertyGroup_Property>(
    FilterBuilderLocalizedPropertyGroup_Property(), 
    LocalizedPropertyGroup_PropertyRelationBuilder,
    uri != undefined ? uri + 'LocalizedPropertyGroup_Property' : 'http://localhost:5000/odata/LocalizedPropertyGroup_Property',
    LocalizedPropertyGroup_PropertyParser,
    LocalizedPropertyGroup_PropertyOrderBy("")
  )

  export const LoginAttemptQuery = (uri?: string) => mk_query<LoginAttempt>(
    FilterBuilderLoginAttempt(), 
    LoginAttemptRelationBuilder,
    uri != undefined ? uri + 'LoginAttempt' : 'http://localhost:5000/odata/LoginAttempt',
    LoginAttemptParser,
    LoginAttemptOrderBy("")
  )

  export const ProductQuery = (uri?: string) => mk_query<Product>(
    FilterBuilderProduct(), 
    ProductRelationBuilder,
    uri != undefined ? uri + 'Product' : 'http://localhost:5000/odata/Product',
    ProductParser,
    ProductOrderBy("")
  )

  export const ProductHeaderQuery = (uri?: string) => mk_query<ProductHeader>(
    FilterBuilderProductHeader(), 
    ProductHeaderRelationBuilder,
    uri != undefined ? uri + 'ProductHeader' : 'http://localhost:5000/odata/ProductHeader',
    ProductHeaderParser,
    ProductHeaderOrderBy("")
  )

  export const PropertyQuery = (uri?: string) => mk_query<Property>(
    FilterBuilderProperty(), 
    PropertyRelationBuilder,
    uri != undefined ? uri + 'Property' : 'http://localhost:5000/odata/Property',
    PropertyParser,
    PropertyOrderBy("")
  )

  export const SessionQuery = (uri?: string) => mk_query<Session>(
    FilterBuilderSession(), 
    SessionRelationBuilder,
    uri != undefined ? uri + 'Session' : 'http://localhost:5000/odata/Session',
    SessionParser,
    SessionOrderBy("")
  )

  export const SubsidiaryQuery = (uri?: string) => mk_query<Subsidiary>(
    FilterBuilderSubsidiary(), 
    SubsidiaryRelationBuilder,
    uri != undefined ? uri + 'Subsidiary' : 'http://localhost:5000/odata/Subsidiary',
    SubsidiaryParser,
    SubsidiaryOrderBy("")
  )

  export const SubsidiaryProductQuery = (uri?: string) => mk_query<SubsidiaryProduct>(
    FilterBuilderSubsidiaryProduct(), 
    SubsidiaryProductRelationBuilder,
    uri != undefined ? uri + 'SubsidiaryProduct' : 'http://localhost:5000/odata/SubsidiaryProduct',
    SubsidiaryProductParser,
    SubsidiaryProductOrderBy("")
  )

  export const SubsidiaryProductManagerQuery = (uri?: string) => mk_query<SubsidiaryProductManager>(
    FilterBuilderSubsidiaryProductManager(), 
    SubsidiaryProductManagerRelationBuilder,
    uri != undefined ? uri + 'SubsidiaryProductManager' : 'http://localhost:5000/odata/SubsidiaryProductManager',
    SubsidiaryProductManagerParser,
    SubsidiaryProductManagerOrderBy("")
  )

  export const SubsidiaryProduct_LocalizedProductHeaderQuery = (uri?: string) => mk_query<SubsidiaryProduct_LocalizedProductHeader>(
    FilterBuilderSubsidiaryProduct_LocalizedProductHeader(), 
    SubsidiaryProduct_LocalizedProductHeaderRelationBuilder,
    uri != undefined ? uri + 'SubsidiaryProduct_LocalizedProductHeader' : 'http://localhost:5000/odata/SubsidiaryProduct_LocalizedProductHeader',
    SubsidiaryProduct_LocalizedProductHeaderParser,
    SubsidiaryProduct_LocalizedProductHeaderOrderBy("")
  )

  export const SubsidiaryProduct_LocalizedPropertyGroupQuery = (uri?: string) => mk_query<SubsidiaryProduct_LocalizedPropertyGroup>(
    FilterBuilderSubsidiaryProduct_LocalizedPropertyGroup(), 
    SubsidiaryProduct_LocalizedPropertyGroupRelationBuilder,
    uri != undefined ? uri + 'SubsidiaryProduct_LocalizedPropertyGroup' : 'http://localhost:5000/odata/SubsidiaryProduct_LocalizedPropertyGroup',
    SubsidiaryProduct_LocalizedPropertyGroupParser,
    SubsidiaryProduct_LocalizedPropertyGroupOrderBy("")
  )

  export const SubsidiaryProduct_PropertyQuery = (uri?: string) => mk_query<SubsidiaryProduct_Property>(
    FilterBuilderSubsidiaryProduct_Property(), 
    SubsidiaryProduct_PropertyRelationBuilder,
    uri != undefined ? uri + 'SubsidiaryProduct_Property' : 'http://localhost:5000/odata/SubsidiaryProduct_Property',
    SubsidiaryProduct_PropertyParser,
    SubsidiaryProduct_PropertyOrderBy("")
  )

  export const SubsidiaryProduct_UnLocalizedProductHeaderQuery = (uri?: string) => mk_query<SubsidiaryProduct_UnLocalizedProductHeader>(
    FilterBuilderSubsidiaryProduct_UnLocalizedProductHeader(), 
    SubsidiaryProduct_UnLocalizedProductHeaderRelationBuilder,
    uri != undefined ? uri + 'SubsidiaryProduct_UnLocalizedProductHeader' : 'http://localhost:5000/odata/SubsidiaryProduct_UnLocalizedProductHeader',
    SubsidiaryProduct_UnLocalizedProductHeaderParser,
    SubsidiaryProduct_UnLocalizedProductHeaderOrderBy("")
  )

  export const Subsidiary_LocaleQuery = (uri?: string) => mk_query<Subsidiary_Locale>(
    FilterBuilderSubsidiary_Locale(), 
    Subsidiary_LocaleRelationBuilder,
    uri != undefined ? uri + 'Subsidiary_Locale' : 'http://localhost:5000/odata/Subsidiary_Locale',
    Subsidiary_LocaleParser,
    Subsidiary_LocaleOrderBy("")
  )

  export const Subsidiary_SubsidiaryProductQuery = (uri?: string) => mk_query<Subsidiary_SubsidiaryProduct>(
    FilterBuilderSubsidiary_SubsidiaryProduct(), 
    Subsidiary_SubsidiaryProductRelationBuilder,
    uri != undefined ? uri + 'Subsidiary_SubsidiaryProduct' : 'http://localhost:5000/odata/Subsidiary_SubsidiaryProduct',
    Subsidiary_SubsidiaryProductParser,
    Subsidiary_SubsidiaryProductOrderBy("")
  )

  export const Subsidiary_SubsidiaryProductManagerQuery = (uri?: string) => mk_query<Subsidiary_SubsidiaryProductManager>(
    FilterBuilderSubsidiary_SubsidiaryProductManager(), 
    Subsidiary_SubsidiaryProductManagerRelationBuilder,
    uri != undefined ? uri + 'Subsidiary_SubsidiaryProductManager' : 'http://localhost:5000/odata/Subsidiary_SubsidiaryProductManager',
    Subsidiary_SubsidiaryProductManagerParser,
    Subsidiary_SubsidiaryProductManagerOrderBy("")
  )

  export const UnLocalizedProductHeaderQuery = (uri?: string) => mk_query<UnLocalizedProductHeader>(
    FilterBuilderUnLocalizedProductHeader(), 
    UnLocalizedProductHeaderRelationBuilder,
    uri != undefined ? uri + 'UnLocalizedProductHeader' : 'http://localhost:5000/odata/UnLocalizedProductHeader',
    UnLocalizedProductHeaderParser,
    UnLocalizedProductHeaderOrderBy("")
  )

  export const UnLocalizedProductHeader_UspQuery = (uri?: string) => mk_query<UnLocalizedProductHeader_Usp>(
    FilterBuilderUnLocalizedProductHeader_Usp(), 
    UnLocalizedProductHeader_UspRelationBuilder,
    uri != undefined ? uri + 'UnLocalizedProductHeader_Usp' : 'http://localhost:5000/odata/UnLocalizedProductHeader_Usp',
    UnLocalizedProductHeader_UspParser,
    UnLocalizedProductHeader_UspOrderBy("")
  )

  export const UspQuery = (uri?: string) => mk_query<Usp>(
    FilterBuilderUsp(), 
    UspRelationBuilder,
    uri != undefined ? uri + 'Usp' : 'http://localhost:5000/odata/Usp',
    UspParser,
    UspOrderBy("")
  )



export type Admin = {
    Id: number
    CreatedDate: Date
    Username: string | null
    Email: string | null
    Language: string | null
    PasswordHash: string | null
    PasswordSalt: string | null
    LastLoginAttempt: Date
    SecurityStamp: string | null
    EmailConfirmed: boolean
} & {

}


function FilterBuilderAdmin(prefix?: string) : FilterBuilderComplex<Admin> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Username: new FilterBuilderString(mk_prefix('Username', prefix)),
      Email: new FilterBuilderString(mk_prefix('Email', prefix)),
      Language: new FilterBuilderString(mk_prefix('Language', prefix)),
      PasswordHash: new FilterBuilderString(mk_prefix('PasswordHash', prefix)),
      PasswordSalt: new FilterBuilderString(mk_prefix('PasswordSalt', prefix)),
      LastLoginAttempt: new FilterBuilderDate(mk_prefix('LastLoginAttempt', prefix)),
      SecurityStamp: new FilterBuilderString(mk_prefix('SecurityStamp', prefix)),
      EmailConfirmed: new FilterBuilderBoolean(mk_prefix('EmailConfirmed', prefix)),
    
  }
}


const AdminRelationBuilder: RelationBuilder<RelationsOf<Admin>> = {

}


const  AdminParser : EntityParser<Admin>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Username: parseNullString,
      Email: parseNullString,
      Language: parseNullString,
      PasswordHash: parseNullString,
      PasswordSalt: parseNullString,
      LastLoginAttempt: parseDate,
      SecurityStamp: parseNullString,
      EmailConfirmed: parseBoolean,
  
}


const AdminOrderBy : (p: string) => OrderByBuilderComplex<Admin> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Username:  new OrderByProp(p ? p + "/Username" : "Username"),
      Email:  new OrderByProp(p ? p + "/Email" : "Email"),
      Language:  new OrderByProp(p ? p + "/Language" : "Language"),
      PasswordHash:  new OrderByProp(p ? p + "/PasswordHash" : "PasswordHash"),
      PasswordSalt:  new OrderByProp(p ? p + "/PasswordSalt" : "PasswordSalt"),
      LastLoginAttempt:  new OrderByProp(p ? p + "/LastLoginAttempt" : "LastLoginAttempt"),
      SecurityStamp:  new OrderByProp(p ? p + "/SecurityStamp" : "SecurityStamp"),
      EmailConfirmed:  new OrderByProp(p ? p + "/EmailConfirmed" : "EmailConfirmed"),
  
})



export type Application = {
    Id: number
    CreatedDate: Date
} & {

}


function FilterBuilderApplication(prefix?: string) : FilterBuilderComplex<Application> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
    
  }
}


const ApplicationRelationBuilder: RelationBuilder<RelationsOf<Application>> = {

}


const  ApplicationParser : EntityParser<Application>= {
  Id: parseNumber,
      CreatedDate: parseDate,
  
}


const ApplicationOrderBy : (p: string) => OrderByBuilderComplex<Application> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
  
})



export type GlobalProduct = {
    Id: number
    CreatedDate: Date
    kind: string | null
    name: string | null
    image: string | null
    hasBIM: boolean
    hasTechnicalDrawing: boolean
} & {
  GlobalProduct_LocalizedProductHeader: List<GlobalProduct_LocalizedProductHeader>
    GlobalProduct_LocalizedPropertyGroup: List<GlobalProduct_LocalizedPropertyGroup>
    GlobalProduct_Property: List<GlobalProduct_Property>
    GlobalProduct_UnLocalizedProductHeader: List<GlobalProduct_UnLocalizedProductHeader>
}


function FilterBuilderGlobalProduct(prefix?: string) : FilterBuilderComplex<GlobalProduct> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      kind: new FilterBuilderString(mk_prefix('kind', prefix)),
      name: new FilterBuilderString(mk_prefix('name', prefix)),
      image: new FilterBuilderString(mk_prefix('image', prefix)),
      hasBIM: new FilterBuilderBoolean(mk_prefix('hasBIM', prefix)),
      hasTechnicalDrawing: new FilterBuilderBoolean(mk_prefix('hasTechnicalDrawing', prefix)),
    GlobalProduct_LocalizedProductHeader: new FilterBuilderCollection<GlobalProduct_LocalizedProductHeader>(mk_prefix('GlobalProduct_LocalizedProductHeader', prefix), s => FilterBuilderGlobalProduct_LocalizedProductHeader(s)),
      GlobalProduct_LocalizedPropertyGroup: new FilterBuilderCollection<GlobalProduct_LocalizedPropertyGroup>(mk_prefix('GlobalProduct_LocalizedPropertyGroup', prefix), s => FilterBuilderGlobalProduct_LocalizedPropertyGroup(s)),
      GlobalProduct_Property: new FilterBuilderCollection<GlobalProduct_Property>(mk_prefix('GlobalProduct_Property', prefix), s => FilterBuilderGlobalProduct_Property(s)),
      GlobalProduct_UnLocalizedProductHeader: new FilterBuilderCollection<GlobalProduct_UnLocalizedProductHeader>(mk_prefix('GlobalProduct_UnLocalizedProductHeader', prefix), s => FilterBuilderGlobalProduct_UnLocalizedProductHeader(s)),
  }
}


const GlobalProductRelationBuilder: RelationBuilder<RelationsOf<GlobalProduct>> = {
GlobalProduct_LocalizedProductHeader: () => mk_rel_query(
    'GlobalProduct_LocalizedProductHeader',
    FilterBuilderGlobalProduct_LocalizedProductHeader(),
    GlobalProduct_LocalizedProductHeaderRelationBuilder,
    GlobalProduct_LocalizedProductHeaderParser
  ),

GlobalProduct_LocalizedPropertyGroup: () => mk_rel_query(
    'GlobalProduct_LocalizedPropertyGroup',
    FilterBuilderGlobalProduct_LocalizedPropertyGroup(),
    GlobalProduct_LocalizedPropertyGroupRelationBuilder,
    GlobalProduct_LocalizedPropertyGroupParser
  ),

GlobalProduct_Property: () => mk_rel_query(
    'GlobalProduct_Property',
    FilterBuilderGlobalProduct_Property(),
    GlobalProduct_PropertyRelationBuilder,
    GlobalProduct_PropertyParser
  ),

GlobalProduct_UnLocalizedProductHeader: () => mk_rel_query(
    'GlobalProduct_UnLocalizedProductHeader',
    FilterBuilderGlobalProduct_UnLocalizedProductHeader(),
    GlobalProduct_UnLocalizedProductHeaderRelationBuilder,
    GlobalProduct_UnLocalizedProductHeaderParser
  ),

}


const  GlobalProductParser : EntityParser<GlobalProduct>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      kind: parseNullString,
      name: parseNullString,
      image: parseNullString,
      hasBIM: parseBoolean,
      hasTechnicalDrawing: parseBoolean,
  GlobalProduct_LocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      GlobalProduct_LocalizedPropertyGroup: p => parseCollection(x => parseEntity(x, p)),
      GlobalProduct_Property: p => parseCollection(x => parseEntity(x, p)),
      GlobalProduct_UnLocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
}


const GlobalProductOrderBy : (p: string) => OrderByBuilderComplex<GlobalProduct> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      kind:  new OrderByProp(p ? p + "/kind" : "kind"),
      name:  new OrderByProp(p ? p + "/name" : "name"),
      image:  new OrderByProp(p ? p + "/image" : "image"),
      hasBIM:  new OrderByProp(p ? p + "/hasBIM" : "hasBIM"),
      hasTechnicalDrawing:  new OrderByProp(p ? p + "/hasTechnicalDrawing" : "hasTechnicalDrawing"),
  GlobalProduct_LocalizedProductHeader:  p => GlobalProduct_LocalizedProductHeaderOrderBy(p ? p + "/GlobalProduct_LocalizedProductHeader" : "GlobalProduct_LocalizedProductHeader"),
      GlobalProduct_LocalizedPropertyGroup:  p => GlobalProduct_LocalizedPropertyGroupOrderBy(p ? p + "/GlobalProduct_LocalizedPropertyGroup" : "GlobalProduct_LocalizedPropertyGroup"),
      GlobalProduct_Property:  p => GlobalProduct_PropertyOrderBy(p ? p + "/GlobalProduct_Property" : "GlobalProduct_Property"),
      GlobalProduct_UnLocalizedProductHeader:  p => GlobalProduct_UnLocalizedProductHeaderOrderBy(p ? p + "/GlobalProduct_UnLocalizedProductHeader" : "GlobalProduct_UnLocalizedProductHeader"),
})



export type GlobalProductManager = {
    Id: number
    CreatedDate: Date
    Username: string | null
    Email: string | null
    Language: string | null
    PasswordHash: string | null
    PasswordSalt: string | null
    LastLoginAttempt: Date
    SecurityStamp: string | null
    EmailConfirmed: boolean
} & {

}


function FilterBuilderGlobalProductManager(prefix?: string) : FilterBuilderComplex<GlobalProductManager> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Username: new FilterBuilderString(mk_prefix('Username', prefix)),
      Email: new FilterBuilderString(mk_prefix('Email', prefix)),
      Language: new FilterBuilderString(mk_prefix('Language', prefix)),
      PasswordHash: new FilterBuilderString(mk_prefix('PasswordHash', prefix)),
      PasswordSalt: new FilterBuilderString(mk_prefix('PasswordSalt', prefix)),
      LastLoginAttempt: new FilterBuilderDate(mk_prefix('LastLoginAttempt', prefix)),
      SecurityStamp: new FilterBuilderString(mk_prefix('SecurityStamp', prefix)),
      EmailConfirmed: new FilterBuilderBoolean(mk_prefix('EmailConfirmed', prefix)),
    
  }
}


const GlobalProductManagerRelationBuilder: RelationBuilder<RelationsOf<GlobalProductManager>> = {

}


const  GlobalProductManagerParser : EntityParser<GlobalProductManager>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Username: parseNullString,
      Email: parseNullString,
      Language: parseNullString,
      PasswordHash: parseNullString,
      PasswordSalt: parseNullString,
      LastLoginAttempt: parseDate,
      SecurityStamp: parseNullString,
      EmailConfirmed: parseBoolean,
  
}


const GlobalProductManagerOrderBy : (p: string) => OrderByBuilderComplex<GlobalProductManager> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Username:  new OrderByProp(p ? p + "/Username" : "Username"),
      Email:  new OrderByProp(p ? p + "/Email" : "Email"),
      Language:  new OrderByProp(p ? p + "/Language" : "Language"),
      PasswordHash:  new OrderByProp(p ? p + "/PasswordHash" : "PasswordHash"),
      PasswordSalt:  new OrderByProp(p ? p + "/PasswordSalt" : "PasswordSalt"),
      LastLoginAttempt:  new OrderByProp(p ? p + "/LastLoginAttempt" : "LastLoginAttempt"),
      SecurityStamp:  new OrderByProp(p ? p + "/SecurityStamp" : "SecurityStamp"),
      EmailConfirmed:  new OrderByProp(p ? p + "/EmailConfirmed" : "EmailConfirmed"),
  
})



export type GlobalProduct_LocalizedProductHeader = {
    Id: number
    GlobalProductId: number
    LocalizedProductHeaderId: number
} & {
  GlobalProduct: List<GlobalProduct>
    LocalizedProductHeader: List<LocalizedProductHeader>
}


function FilterBuilderGlobalProduct_LocalizedProductHeader(prefix?: string) : FilterBuilderComplex<GlobalProduct_LocalizedProductHeader> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      GlobalProductId: new FilterBuilderNumber(mk_prefix('GlobalProductId', prefix)),
      LocalizedProductHeaderId: new FilterBuilderNumber(mk_prefix('LocalizedProductHeaderId', prefix)),
    GlobalProduct: new FilterBuilderCollection<GlobalProduct>(mk_prefix('GlobalProduct', prefix), s => FilterBuilderGlobalProduct(s)),
      LocalizedProductHeader: new FilterBuilderCollection<LocalizedProductHeader>(mk_prefix('LocalizedProductHeader', prefix), s => FilterBuilderLocalizedProductHeader(s)),
  }
}


const GlobalProduct_LocalizedProductHeaderRelationBuilder: RelationBuilder<RelationsOf<GlobalProduct_LocalizedProductHeader>> = {
GlobalProduct: () => mk_rel_query(
    'GlobalProduct',
    FilterBuilderGlobalProduct(),
    GlobalProductRelationBuilder,
    GlobalProductParser
  ),

LocalizedProductHeader: () => mk_rel_query(
    'LocalizedProductHeader',
    FilterBuilderLocalizedProductHeader(),
    LocalizedProductHeaderRelationBuilder,
    LocalizedProductHeaderParser
  ),

}


const  GlobalProduct_LocalizedProductHeaderParser : EntityParser<GlobalProduct_LocalizedProductHeader>= {
  Id: parseNumber,
      GlobalProductId: parseNumber,
      LocalizedProductHeaderId: parseNumber,
  GlobalProduct: p => parseCollection(x => parseEntity(x, p)),
      LocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
}


const GlobalProduct_LocalizedProductHeaderOrderBy : (p: string) => OrderByBuilderComplex<GlobalProduct_LocalizedProductHeader> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      GlobalProductId:  new OrderByProp(p ? p + "/GlobalProductId" : "GlobalProductId"),
      LocalizedProductHeaderId:  new OrderByProp(p ? p + "/LocalizedProductHeaderId" : "LocalizedProductHeaderId"),
  GlobalProduct:  p => GlobalProductOrderBy(p ? p + "/GlobalProduct" : "GlobalProduct"),
      LocalizedProductHeader:  p => LocalizedProductHeaderOrderBy(p ? p + "/LocalizedProductHeader" : "LocalizedProductHeader"),
})



export type GlobalProduct_LocalizedPropertyGroup = {
    Id: number
    GlobalProductId: number
    LocalizedPropertyGroupId: number
} & {
  GlobalProduct: List<GlobalProduct>
    LocalizedPropertyGroup: List<LocalizedPropertyGroup>
}


function FilterBuilderGlobalProduct_LocalizedPropertyGroup(prefix?: string) : FilterBuilderComplex<GlobalProduct_LocalizedPropertyGroup> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      GlobalProductId: new FilterBuilderNumber(mk_prefix('GlobalProductId', prefix)),
      LocalizedPropertyGroupId: new FilterBuilderNumber(mk_prefix('LocalizedPropertyGroupId', prefix)),
    GlobalProduct: new FilterBuilderCollection<GlobalProduct>(mk_prefix('GlobalProduct', prefix), s => FilterBuilderGlobalProduct(s)),
      LocalizedPropertyGroup: new FilterBuilderCollection<LocalizedPropertyGroup>(mk_prefix('LocalizedPropertyGroup', prefix), s => FilterBuilderLocalizedPropertyGroup(s)),
  }
}


const GlobalProduct_LocalizedPropertyGroupRelationBuilder: RelationBuilder<RelationsOf<GlobalProduct_LocalizedPropertyGroup>> = {
GlobalProduct: () => mk_rel_query(
    'GlobalProduct',
    FilterBuilderGlobalProduct(),
    GlobalProductRelationBuilder,
    GlobalProductParser
  ),

LocalizedPropertyGroup: () => mk_rel_query(
    'LocalizedPropertyGroup',
    FilterBuilderLocalizedPropertyGroup(),
    LocalizedPropertyGroupRelationBuilder,
    LocalizedPropertyGroupParser
  ),

}


const  GlobalProduct_LocalizedPropertyGroupParser : EntityParser<GlobalProduct_LocalizedPropertyGroup>= {
  Id: parseNumber,
      GlobalProductId: parseNumber,
      LocalizedPropertyGroupId: parseNumber,
  GlobalProduct: p => parseCollection(x => parseEntity(x, p)),
      LocalizedPropertyGroup: p => parseCollection(x => parseEntity(x, p)),
}


const GlobalProduct_LocalizedPropertyGroupOrderBy : (p: string) => OrderByBuilderComplex<GlobalProduct_LocalizedPropertyGroup> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      GlobalProductId:  new OrderByProp(p ? p + "/GlobalProductId" : "GlobalProductId"),
      LocalizedPropertyGroupId:  new OrderByProp(p ? p + "/LocalizedPropertyGroupId" : "LocalizedPropertyGroupId"),
  GlobalProduct:  p => GlobalProductOrderBy(p ? p + "/GlobalProduct" : "GlobalProduct"),
      LocalizedPropertyGroup:  p => LocalizedPropertyGroupOrderBy(p ? p + "/LocalizedPropertyGroup" : "LocalizedPropertyGroup"),
})



export type GlobalProduct_Property = {
    Id: number
    GlobalProductId: number
    PropertyId: number
} & {
  GlobalProduct: List<GlobalProduct>
    Property: List<Property>
}


function FilterBuilderGlobalProduct_Property(prefix?: string) : FilterBuilderComplex<GlobalProduct_Property> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      GlobalProductId: new FilterBuilderNumber(mk_prefix('GlobalProductId', prefix)),
      PropertyId: new FilterBuilderNumber(mk_prefix('PropertyId', prefix)),
    GlobalProduct: new FilterBuilderCollection<GlobalProduct>(mk_prefix('GlobalProduct', prefix), s => FilterBuilderGlobalProduct(s)),
      Property: new FilterBuilderCollection<Property>(mk_prefix('Property', prefix), s => FilterBuilderProperty(s)),
  }
}


const GlobalProduct_PropertyRelationBuilder: RelationBuilder<RelationsOf<GlobalProduct_Property>> = {
GlobalProduct: () => mk_rel_query(
    'GlobalProduct',
    FilterBuilderGlobalProduct(),
    GlobalProductRelationBuilder,
    GlobalProductParser
  ),

Property: () => mk_rel_query(
    'Property',
    FilterBuilderProperty(),
    PropertyRelationBuilder,
    PropertyParser
  ),

}


const  GlobalProduct_PropertyParser : EntityParser<GlobalProduct_Property>= {
  Id: parseNumber,
      GlobalProductId: parseNumber,
      PropertyId: parseNumber,
  GlobalProduct: p => parseCollection(x => parseEntity(x, p)),
      Property: p => parseCollection(x => parseEntity(x, p)),
}


const GlobalProduct_PropertyOrderBy : (p: string) => OrderByBuilderComplex<GlobalProduct_Property> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      GlobalProductId:  new OrderByProp(p ? p + "/GlobalProductId" : "GlobalProductId"),
      PropertyId:  new OrderByProp(p ? p + "/PropertyId" : "PropertyId"),
  GlobalProduct:  p => GlobalProductOrderBy(p ? p + "/GlobalProduct" : "GlobalProduct"),
      Property:  p => PropertyOrderBy(p ? p + "/Property" : "Property"),
})



export type GlobalProduct_UnLocalizedProductHeader = {
    Id: number
    GlobalProductId: number
    UnLocalizedProductHeaderId: number
} & {
  GlobalProduct: List<GlobalProduct>
    UnLocalizedProductHeader: List<UnLocalizedProductHeader>
}


function FilterBuilderGlobalProduct_UnLocalizedProductHeader(prefix?: string) : FilterBuilderComplex<GlobalProduct_UnLocalizedProductHeader> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      GlobalProductId: new FilterBuilderNumber(mk_prefix('GlobalProductId', prefix)),
      UnLocalizedProductHeaderId: new FilterBuilderNumber(mk_prefix('UnLocalizedProductHeaderId', prefix)),
    GlobalProduct: new FilterBuilderCollection<GlobalProduct>(mk_prefix('GlobalProduct', prefix), s => FilterBuilderGlobalProduct(s)),
      UnLocalizedProductHeader: new FilterBuilderCollection<UnLocalizedProductHeader>(mk_prefix('UnLocalizedProductHeader', prefix), s => FilterBuilderUnLocalizedProductHeader(s)),
  }
}


const GlobalProduct_UnLocalizedProductHeaderRelationBuilder: RelationBuilder<RelationsOf<GlobalProduct_UnLocalizedProductHeader>> = {
GlobalProduct: () => mk_rel_query(
    'GlobalProduct',
    FilterBuilderGlobalProduct(),
    GlobalProductRelationBuilder,
    GlobalProductParser
  ),

UnLocalizedProductHeader: () => mk_rel_query(
    'UnLocalizedProductHeader',
    FilterBuilderUnLocalizedProductHeader(),
    UnLocalizedProductHeaderRelationBuilder,
    UnLocalizedProductHeaderParser
  ),

}


const  GlobalProduct_UnLocalizedProductHeaderParser : EntityParser<GlobalProduct_UnLocalizedProductHeader>= {
  Id: parseNumber,
      GlobalProductId: parseNumber,
      UnLocalizedProductHeaderId: parseNumber,
  GlobalProduct: p => parseCollection(x => parseEntity(x, p)),
      UnLocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
}


const GlobalProduct_UnLocalizedProductHeaderOrderBy : (p: string) => OrderByBuilderComplex<GlobalProduct_UnLocalizedProductHeader> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      GlobalProductId:  new OrderByProp(p ? p + "/GlobalProductId" : "GlobalProductId"),
      UnLocalizedProductHeaderId:  new OrderByProp(p ? p + "/UnLocalizedProductHeaderId" : "UnLocalizedProductHeaderId"),
  GlobalProduct:  p => GlobalProductOrderBy(p ? p + "/GlobalProduct" : "GlobalProduct"),
      UnLocalizedProductHeader:  p => UnLocalizedProductHeaderOrderBy(p ? p + "/UnLocalizedProductHeader" : "UnLocalizedProductHeader"),
})



export type Locale = {
    Id: number
    CreatedDate: Date
    region: string | null
    language: string | null
} & {
  LocalizedProductHeader_Locale: List<LocalizedProductHeader_Locale>
    LocalizedPropertyGroup_Locale: List<LocalizedPropertyGroup_Locale>
    Subsidiary_Locale: List<Subsidiary_Locale>
}


function FilterBuilderLocale(prefix?: string) : FilterBuilderComplex<Locale> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      region: new FilterBuilderString(mk_prefix('region', prefix)),
      language: new FilterBuilderString(mk_prefix('language', prefix)),
    LocalizedProductHeader_Locale: new FilterBuilderCollection<LocalizedProductHeader_Locale>(mk_prefix('LocalizedProductHeader_Locale', prefix), s => FilterBuilderLocalizedProductHeader_Locale(s)),
      LocalizedPropertyGroup_Locale: new FilterBuilderCollection<LocalizedPropertyGroup_Locale>(mk_prefix('LocalizedPropertyGroup_Locale', prefix), s => FilterBuilderLocalizedPropertyGroup_Locale(s)),
      Subsidiary_Locale: new FilterBuilderCollection<Subsidiary_Locale>(mk_prefix('Subsidiary_Locale', prefix), s => FilterBuilderSubsidiary_Locale(s)),
  }
}


const LocaleRelationBuilder: RelationBuilder<RelationsOf<Locale>> = {
LocalizedProductHeader_Locale: () => mk_rel_query(
    'LocalizedProductHeader_Locale',
    FilterBuilderLocalizedProductHeader_Locale(),
    LocalizedProductHeader_LocaleRelationBuilder,
    LocalizedProductHeader_LocaleParser
  ),

LocalizedPropertyGroup_Locale: () => mk_rel_query(
    'LocalizedPropertyGroup_Locale',
    FilterBuilderLocalizedPropertyGroup_Locale(),
    LocalizedPropertyGroup_LocaleRelationBuilder,
    LocalizedPropertyGroup_LocaleParser
  ),

Subsidiary_Locale: () => mk_rel_query(
    'Subsidiary_Locale',
    FilterBuilderSubsidiary_Locale(),
    Subsidiary_LocaleRelationBuilder,
    Subsidiary_LocaleParser
  ),

}


const  LocaleParser : EntityParser<Locale>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      region: parseNullString,
      language: parseNullString,
  LocalizedProductHeader_Locale: p => parseCollection(x => parseEntity(x, p)),
      LocalizedPropertyGroup_Locale: p => parseCollection(x => parseEntity(x, p)),
      Subsidiary_Locale: p => parseCollection(x => parseEntity(x, p)),
}


const LocaleOrderBy : (p: string) => OrderByBuilderComplex<Locale> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      region:  new OrderByProp(p ? p + "/region" : "region"),
      language:  new OrderByProp(p ? p + "/language" : "language"),
  LocalizedProductHeader_Locale:  p => LocalizedProductHeader_LocaleOrderBy(p ? p + "/LocalizedProductHeader_Locale" : "LocalizedProductHeader_Locale"),
      LocalizedPropertyGroup_Locale:  p => LocalizedPropertyGroup_LocaleOrderBy(p ? p + "/LocalizedPropertyGroup_Locale" : "LocalizedPropertyGroup_Locale"),
      Subsidiary_Locale:  p => Subsidiary_LocaleOrderBy(p ? p + "/Subsidiary_Locale" : "Subsidiary_Locale"),
})



export type LocalizedProductHeader = {
    Id: number
    CreatedDate: Date
    pageTitle: string | null
    descriptionTitle: string | null
    description: string | null
} & {
  GlobalProduct_LocalizedProductHeader: List<GlobalProduct_LocalizedProductHeader>
    LocalizedProductHeader_Locale: List<LocalizedProductHeader_Locale>
    LocalizedProductHeader_Usp: List<LocalizedProductHeader_Usp>
    SubsidiaryProduct_LocalizedProductHeader: List<SubsidiaryProduct_LocalizedProductHeader>
}


function FilterBuilderLocalizedProductHeader(prefix?: string) : FilterBuilderComplex<LocalizedProductHeader> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      pageTitle: new FilterBuilderString(mk_prefix('pageTitle', prefix)),
      descriptionTitle: new FilterBuilderString(mk_prefix('descriptionTitle', prefix)),
      description: new FilterBuilderString(mk_prefix('description', prefix)),
    GlobalProduct_LocalizedProductHeader: new FilterBuilderCollection<GlobalProduct_LocalizedProductHeader>(mk_prefix('GlobalProduct_LocalizedProductHeader', prefix), s => FilterBuilderGlobalProduct_LocalizedProductHeader(s)),
      LocalizedProductHeader_Locale: new FilterBuilderCollection<LocalizedProductHeader_Locale>(mk_prefix('LocalizedProductHeader_Locale', prefix), s => FilterBuilderLocalizedProductHeader_Locale(s)),
      LocalizedProductHeader_Usp: new FilterBuilderCollection<LocalizedProductHeader_Usp>(mk_prefix('LocalizedProductHeader_Usp', prefix), s => FilterBuilderLocalizedProductHeader_Usp(s)),
      SubsidiaryProduct_LocalizedProductHeader: new FilterBuilderCollection<SubsidiaryProduct_LocalizedProductHeader>(mk_prefix('SubsidiaryProduct_LocalizedProductHeader', prefix), s => FilterBuilderSubsidiaryProduct_LocalizedProductHeader(s)),
  }
}


const LocalizedProductHeaderRelationBuilder: RelationBuilder<RelationsOf<LocalizedProductHeader>> = {
GlobalProduct_LocalizedProductHeader: () => mk_rel_query(
    'GlobalProduct_LocalizedProductHeader',
    FilterBuilderGlobalProduct_LocalizedProductHeader(),
    GlobalProduct_LocalizedProductHeaderRelationBuilder,
    GlobalProduct_LocalizedProductHeaderParser
  ),

LocalizedProductHeader_Locale: () => mk_rel_query(
    'LocalizedProductHeader_Locale',
    FilterBuilderLocalizedProductHeader_Locale(),
    LocalizedProductHeader_LocaleRelationBuilder,
    LocalizedProductHeader_LocaleParser
  ),

LocalizedProductHeader_Usp: () => mk_rel_query(
    'LocalizedProductHeader_Usp',
    FilterBuilderLocalizedProductHeader_Usp(),
    LocalizedProductHeader_UspRelationBuilder,
    LocalizedProductHeader_UspParser
  ),

SubsidiaryProduct_LocalizedProductHeader: () => mk_rel_query(
    'SubsidiaryProduct_LocalizedProductHeader',
    FilterBuilderSubsidiaryProduct_LocalizedProductHeader(),
    SubsidiaryProduct_LocalizedProductHeaderRelationBuilder,
    SubsidiaryProduct_LocalizedProductHeaderParser
  ),

}


const  LocalizedProductHeaderParser : EntityParser<LocalizedProductHeader>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      pageTitle: parseNullString,
      descriptionTitle: parseNullString,
      description: parseNullString,
  GlobalProduct_LocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      LocalizedProductHeader_Locale: p => parseCollection(x => parseEntity(x, p)),
      LocalizedProductHeader_Usp: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct_LocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
}


const LocalizedProductHeaderOrderBy : (p: string) => OrderByBuilderComplex<LocalizedProductHeader> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      pageTitle:  new OrderByProp(p ? p + "/pageTitle" : "pageTitle"),
      descriptionTitle:  new OrderByProp(p ? p + "/descriptionTitle" : "descriptionTitle"),
      description:  new OrderByProp(p ? p + "/description" : "description"),
  GlobalProduct_LocalizedProductHeader:  p => GlobalProduct_LocalizedProductHeaderOrderBy(p ? p + "/GlobalProduct_LocalizedProductHeader" : "GlobalProduct_LocalizedProductHeader"),
      LocalizedProductHeader_Locale:  p => LocalizedProductHeader_LocaleOrderBy(p ? p + "/LocalizedProductHeader_Locale" : "LocalizedProductHeader_Locale"),
      LocalizedProductHeader_Usp:  p => LocalizedProductHeader_UspOrderBy(p ? p + "/LocalizedProductHeader_Usp" : "LocalizedProductHeader_Usp"),
      SubsidiaryProduct_LocalizedProductHeader:  p => SubsidiaryProduct_LocalizedProductHeaderOrderBy(p ? p + "/SubsidiaryProduct_LocalizedProductHeader" : "SubsidiaryProduct_LocalizedProductHeader"),
})



export type LocalizedProductHeader_Locale = {
    Id: number
    LocalizedProductHeaderId: number
    LocaleId: number
} & {
  Locale: List<Locale>
    LocalizedProductHeader: List<LocalizedProductHeader>
}


function FilterBuilderLocalizedProductHeader_Locale(prefix?: string) : FilterBuilderComplex<LocalizedProductHeader_Locale> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LocalizedProductHeaderId: new FilterBuilderNumber(mk_prefix('LocalizedProductHeaderId', prefix)),
      LocaleId: new FilterBuilderNumber(mk_prefix('LocaleId', prefix)),
    Locale: new FilterBuilderCollection<Locale>(mk_prefix('Locale', prefix), s => FilterBuilderLocale(s)),
      LocalizedProductHeader: new FilterBuilderCollection<LocalizedProductHeader>(mk_prefix('LocalizedProductHeader', prefix), s => FilterBuilderLocalizedProductHeader(s)),
  }
}


const LocalizedProductHeader_LocaleRelationBuilder: RelationBuilder<RelationsOf<LocalizedProductHeader_Locale>> = {
Locale: () => mk_rel_query(
    'Locale',
    FilterBuilderLocale(),
    LocaleRelationBuilder,
    LocaleParser
  ),

LocalizedProductHeader: () => mk_rel_query(
    'LocalizedProductHeader',
    FilterBuilderLocalizedProductHeader(),
    LocalizedProductHeaderRelationBuilder,
    LocalizedProductHeaderParser
  ),

}


const  LocalizedProductHeader_LocaleParser : EntityParser<LocalizedProductHeader_Locale>= {
  Id: parseNumber,
      LocalizedProductHeaderId: parseNumber,
      LocaleId: parseNumber,
  Locale: p => parseCollection(x => parseEntity(x, p)),
      LocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
}


const LocalizedProductHeader_LocaleOrderBy : (p: string) => OrderByBuilderComplex<LocalizedProductHeader_Locale> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LocalizedProductHeaderId:  new OrderByProp(p ? p + "/LocalizedProductHeaderId" : "LocalizedProductHeaderId"),
      LocaleId:  new OrderByProp(p ? p + "/LocaleId" : "LocaleId"),
  Locale:  p => LocaleOrderBy(p ? p + "/Locale" : "Locale"),
      LocalizedProductHeader:  p => LocalizedProductHeaderOrderBy(p ? p + "/LocalizedProductHeader" : "LocalizedProductHeader"),
})



export type LocalizedProductHeader_Usp = {
    Id: number
    LocalizedProductHeaderId: number
    UspId: number
} & {
  LocalizedProductHeader: List<LocalizedProductHeader>
    Usp: List<Usp>
}


function FilterBuilderLocalizedProductHeader_Usp(prefix?: string) : FilterBuilderComplex<LocalizedProductHeader_Usp> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LocalizedProductHeaderId: new FilterBuilderNumber(mk_prefix('LocalizedProductHeaderId', prefix)),
      UspId: new FilterBuilderNumber(mk_prefix('UspId', prefix)),
    LocalizedProductHeader: new FilterBuilderCollection<LocalizedProductHeader>(mk_prefix('LocalizedProductHeader', prefix), s => FilterBuilderLocalizedProductHeader(s)),
      Usp: new FilterBuilderCollection<Usp>(mk_prefix('Usp', prefix), s => FilterBuilderUsp(s)),
  }
}


const LocalizedProductHeader_UspRelationBuilder: RelationBuilder<RelationsOf<LocalizedProductHeader_Usp>> = {
LocalizedProductHeader: () => mk_rel_query(
    'LocalizedProductHeader',
    FilterBuilderLocalizedProductHeader(),
    LocalizedProductHeaderRelationBuilder,
    LocalizedProductHeaderParser
  ),

Usp: () => mk_rel_query(
    'Usp',
    FilterBuilderUsp(),
    UspRelationBuilder,
    UspParser
  ),

}


const  LocalizedProductHeader_UspParser : EntityParser<LocalizedProductHeader_Usp>= {
  Id: parseNumber,
      LocalizedProductHeaderId: parseNumber,
      UspId: parseNumber,
  LocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      Usp: p => parseCollection(x => parseEntity(x, p)),
}


const LocalizedProductHeader_UspOrderBy : (p: string) => OrderByBuilderComplex<LocalizedProductHeader_Usp> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LocalizedProductHeaderId:  new OrderByProp(p ? p + "/LocalizedProductHeaderId" : "LocalizedProductHeaderId"),
      UspId:  new OrderByProp(p ? p + "/UspId" : "UspId"),
  LocalizedProductHeader:  p => LocalizedProductHeaderOrderBy(p ? p + "/LocalizedProductHeader" : "LocalizedProductHeader"),
      Usp:  p => UspOrderBy(p ? p + "/Usp" : "Usp"),
})



export type LocalizedPropertyGroup = {
    Id: number
    CreatedDate: Date
} & {
  GlobalProduct_LocalizedPropertyGroup: List<GlobalProduct_LocalizedPropertyGroup>
    LocalizedPropertyGroup_Locale: List<LocalizedPropertyGroup_Locale>
    LocalizedPropertyGroup_Property: List<LocalizedPropertyGroup_Property>
    SubsidiaryProduct_LocalizedPropertyGroup: List<SubsidiaryProduct_LocalizedPropertyGroup>
}


function FilterBuilderLocalizedPropertyGroup(prefix?: string) : FilterBuilderComplex<LocalizedPropertyGroup> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
    GlobalProduct_LocalizedPropertyGroup: new FilterBuilderCollection<GlobalProduct_LocalizedPropertyGroup>(mk_prefix('GlobalProduct_LocalizedPropertyGroup', prefix), s => FilterBuilderGlobalProduct_LocalizedPropertyGroup(s)),
      LocalizedPropertyGroup_Locale: new FilterBuilderCollection<LocalizedPropertyGroup_Locale>(mk_prefix('LocalizedPropertyGroup_Locale', prefix), s => FilterBuilderLocalizedPropertyGroup_Locale(s)),
      LocalizedPropertyGroup_Property: new FilterBuilderCollection<LocalizedPropertyGroup_Property>(mk_prefix('LocalizedPropertyGroup_Property', prefix), s => FilterBuilderLocalizedPropertyGroup_Property(s)),
      SubsidiaryProduct_LocalizedPropertyGroup: new FilterBuilderCollection<SubsidiaryProduct_LocalizedPropertyGroup>(mk_prefix('SubsidiaryProduct_LocalizedPropertyGroup', prefix), s => FilterBuilderSubsidiaryProduct_LocalizedPropertyGroup(s)),
  }
}


const LocalizedPropertyGroupRelationBuilder: RelationBuilder<RelationsOf<LocalizedPropertyGroup>> = {
GlobalProduct_LocalizedPropertyGroup: () => mk_rel_query(
    'GlobalProduct_LocalizedPropertyGroup',
    FilterBuilderGlobalProduct_LocalizedPropertyGroup(),
    GlobalProduct_LocalizedPropertyGroupRelationBuilder,
    GlobalProduct_LocalizedPropertyGroupParser
  ),

LocalizedPropertyGroup_Locale: () => mk_rel_query(
    'LocalizedPropertyGroup_Locale',
    FilterBuilderLocalizedPropertyGroup_Locale(),
    LocalizedPropertyGroup_LocaleRelationBuilder,
    LocalizedPropertyGroup_LocaleParser
  ),

LocalizedPropertyGroup_Property: () => mk_rel_query(
    'LocalizedPropertyGroup_Property',
    FilterBuilderLocalizedPropertyGroup_Property(),
    LocalizedPropertyGroup_PropertyRelationBuilder,
    LocalizedPropertyGroup_PropertyParser
  ),

SubsidiaryProduct_LocalizedPropertyGroup: () => mk_rel_query(
    'SubsidiaryProduct_LocalizedPropertyGroup',
    FilterBuilderSubsidiaryProduct_LocalizedPropertyGroup(),
    SubsidiaryProduct_LocalizedPropertyGroupRelationBuilder,
    SubsidiaryProduct_LocalizedPropertyGroupParser
  ),

}


const  LocalizedPropertyGroupParser : EntityParser<LocalizedPropertyGroup>= {
  Id: parseNumber,
      CreatedDate: parseDate,
  GlobalProduct_LocalizedPropertyGroup: p => parseCollection(x => parseEntity(x, p)),
      LocalizedPropertyGroup_Locale: p => parseCollection(x => parseEntity(x, p)),
      LocalizedPropertyGroup_Property: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct_LocalizedPropertyGroup: p => parseCollection(x => parseEntity(x, p)),
}


const LocalizedPropertyGroupOrderBy : (p: string) => OrderByBuilderComplex<LocalizedPropertyGroup> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
  GlobalProduct_LocalizedPropertyGroup:  p => GlobalProduct_LocalizedPropertyGroupOrderBy(p ? p + "/GlobalProduct_LocalizedPropertyGroup" : "GlobalProduct_LocalizedPropertyGroup"),
      LocalizedPropertyGroup_Locale:  p => LocalizedPropertyGroup_LocaleOrderBy(p ? p + "/LocalizedPropertyGroup_Locale" : "LocalizedPropertyGroup_Locale"),
      LocalizedPropertyGroup_Property:  p => LocalizedPropertyGroup_PropertyOrderBy(p ? p + "/LocalizedPropertyGroup_Property" : "LocalizedPropertyGroup_Property"),
      SubsidiaryProduct_LocalizedPropertyGroup:  p => SubsidiaryProduct_LocalizedPropertyGroupOrderBy(p ? p + "/SubsidiaryProduct_LocalizedPropertyGroup" : "SubsidiaryProduct_LocalizedPropertyGroup"),
})



export type LocalizedPropertyGroup_Locale = {
    Id: number
    LocalizedPropertyGroupId: number
    LocaleId: number
} & {
  Locale: List<Locale>
    LocalizedPropertyGroup: List<LocalizedPropertyGroup>
}


function FilterBuilderLocalizedPropertyGroup_Locale(prefix?: string) : FilterBuilderComplex<LocalizedPropertyGroup_Locale> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LocalizedPropertyGroupId: new FilterBuilderNumber(mk_prefix('LocalizedPropertyGroupId', prefix)),
      LocaleId: new FilterBuilderNumber(mk_prefix('LocaleId', prefix)),
    Locale: new FilterBuilderCollection<Locale>(mk_prefix('Locale', prefix), s => FilterBuilderLocale(s)),
      LocalizedPropertyGroup: new FilterBuilderCollection<LocalizedPropertyGroup>(mk_prefix('LocalizedPropertyGroup', prefix), s => FilterBuilderLocalizedPropertyGroup(s)),
  }
}


const LocalizedPropertyGroup_LocaleRelationBuilder: RelationBuilder<RelationsOf<LocalizedPropertyGroup_Locale>> = {
Locale: () => mk_rel_query(
    'Locale',
    FilterBuilderLocale(),
    LocaleRelationBuilder,
    LocaleParser
  ),

LocalizedPropertyGroup: () => mk_rel_query(
    'LocalizedPropertyGroup',
    FilterBuilderLocalizedPropertyGroup(),
    LocalizedPropertyGroupRelationBuilder,
    LocalizedPropertyGroupParser
  ),

}


const  LocalizedPropertyGroup_LocaleParser : EntityParser<LocalizedPropertyGroup_Locale>= {
  Id: parseNumber,
      LocalizedPropertyGroupId: parseNumber,
      LocaleId: parseNumber,
  Locale: p => parseCollection(x => parseEntity(x, p)),
      LocalizedPropertyGroup: p => parseCollection(x => parseEntity(x, p)),
}


const LocalizedPropertyGroup_LocaleOrderBy : (p: string) => OrderByBuilderComplex<LocalizedPropertyGroup_Locale> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LocalizedPropertyGroupId:  new OrderByProp(p ? p + "/LocalizedPropertyGroupId" : "LocalizedPropertyGroupId"),
      LocaleId:  new OrderByProp(p ? p + "/LocaleId" : "LocaleId"),
  Locale:  p => LocaleOrderBy(p ? p + "/Locale" : "Locale"),
      LocalizedPropertyGroup:  p => LocalizedPropertyGroupOrderBy(p ? p + "/LocalizedPropertyGroup" : "LocalizedPropertyGroup"),
})



export type LocalizedPropertyGroup_Property = {
    Id: number
    LocalizedPropertyGroupId: number
    PropertyId: number
} & {
  LocalizedPropertyGroup: List<LocalizedPropertyGroup>
    Property: List<Property>
}


function FilterBuilderLocalizedPropertyGroup_Property(prefix?: string) : FilterBuilderComplex<LocalizedPropertyGroup_Property> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LocalizedPropertyGroupId: new FilterBuilderNumber(mk_prefix('LocalizedPropertyGroupId', prefix)),
      PropertyId: new FilterBuilderNumber(mk_prefix('PropertyId', prefix)),
    LocalizedPropertyGroup: new FilterBuilderCollection<LocalizedPropertyGroup>(mk_prefix('LocalizedPropertyGroup', prefix), s => FilterBuilderLocalizedPropertyGroup(s)),
      Property: new FilterBuilderCollection<Property>(mk_prefix('Property', prefix), s => FilterBuilderProperty(s)),
  }
}


const LocalizedPropertyGroup_PropertyRelationBuilder: RelationBuilder<RelationsOf<LocalizedPropertyGroup_Property>> = {
LocalizedPropertyGroup: () => mk_rel_query(
    'LocalizedPropertyGroup',
    FilterBuilderLocalizedPropertyGroup(),
    LocalizedPropertyGroupRelationBuilder,
    LocalizedPropertyGroupParser
  ),

Property: () => mk_rel_query(
    'Property',
    FilterBuilderProperty(),
    PropertyRelationBuilder,
    PropertyParser
  ),

}


const  LocalizedPropertyGroup_PropertyParser : EntityParser<LocalizedPropertyGroup_Property>= {
  Id: parseNumber,
      LocalizedPropertyGroupId: parseNumber,
      PropertyId: parseNumber,
  LocalizedPropertyGroup: p => parseCollection(x => parseEntity(x, p)),
      Property: p => parseCollection(x => parseEntity(x, p)),
}


const LocalizedPropertyGroup_PropertyOrderBy : (p: string) => OrderByBuilderComplex<LocalizedPropertyGroup_Property> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LocalizedPropertyGroupId:  new OrderByProp(p ? p + "/LocalizedPropertyGroupId" : "LocalizedPropertyGroupId"),
      PropertyId:  new OrderByProp(p ? p + "/PropertyId" : "PropertyId"),
  LocalizedPropertyGroup:  p => LocalizedPropertyGroupOrderBy(p ? p + "/LocalizedPropertyGroup" : "LocalizedPropertyGroup"),
      Property:  p => PropertyOrderBy(p ? p + "/Property" : "Property"),
})



export type LoginAttempt = {
    IpAddress: string | null
    Email: string | null
    Attempts: number
    LastAttempt: Date
} & {

}


function FilterBuilderLoginAttempt(prefix?: string) : FilterBuilderComplex<LoginAttempt> {
  return {
    IpAddress: new FilterBuilderString(mk_prefix('IpAddress', prefix)),
      Email: new FilterBuilderString(mk_prefix('Email', prefix)),
      Attempts: new FilterBuilderNumber(mk_prefix('Attempts', prefix)),
      LastAttempt: new FilterBuilderDate(mk_prefix('LastAttempt', prefix)),
    
  }
}


const LoginAttemptRelationBuilder: RelationBuilder<RelationsOf<LoginAttempt>> = {

}


const  LoginAttemptParser : EntityParser<LoginAttempt>= {
  IpAddress: parseNullString,
      Email: parseNullString,
      Attempts: parseNumber,
      LastAttempt: parseDate,
  
}


const LoginAttemptOrderBy : (p: string) => OrderByBuilderComplex<LoginAttempt> = p => ({
  IpAddress:  new OrderByProp(p ? p + "/IpAddress" : "IpAddress"),
      Email:  new OrderByProp(p ? p + "/Email" : "Email"),
      Attempts:  new OrderByProp(p ? p + "/Attempts" : "Attempts"),
      LastAttempt:  new OrderByProp(p ? p + "/LastAttempt" : "LastAttempt"),
  
})



export type Product = {
    Id: number
    CreatedDate: Date
    kind: string | null
    name: string | null
    image: string | null
    hasBIM: boolean
    hasTechnicalDrawing: boolean
} & {

}


function FilterBuilderProduct(prefix?: string) : FilterBuilderComplex<Product> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      kind: new FilterBuilderString(mk_prefix('kind', prefix)),
      name: new FilterBuilderString(mk_prefix('name', prefix)),
      image: new FilterBuilderString(mk_prefix('image', prefix)),
      hasBIM: new FilterBuilderBoolean(mk_prefix('hasBIM', prefix)),
      hasTechnicalDrawing: new FilterBuilderBoolean(mk_prefix('hasTechnicalDrawing', prefix)),
    
  }
}


const ProductRelationBuilder: RelationBuilder<RelationsOf<Product>> = {

}


const  ProductParser : EntityParser<Product>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      kind: parseNullString,
      name: parseNullString,
      image: parseNullString,
      hasBIM: parseBoolean,
      hasTechnicalDrawing: parseBoolean,
  
}


const ProductOrderBy : (p: string) => OrderByBuilderComplex<Product> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      kind:  new OrderByProp(p ? p + "/kind" : "kind"),
      name:  new OrderByProp(p ? p + "/name" : "name"),
      image:  new OrderByProp(p ? p + "/image" : "image"),
      hasBIM:  new OrderByProp(p ? p + "/hasBIM" : "hasBIM"),
      hasTechnicalDrawing:  new OrderByProp(p ? p + "/hasTechnicalDrawing" : "hasTechnicalDrawing"),
  
})



export type ProductHeader = {
    Id: number
    CreatedDate: Date
    pageTitle: string | null
    descriptionTitle: string | null
    description: string | null
} & {

}


function FilterBuilderProductHeader(prefix?: string) : FilterBuilderComplex<ProductHeader> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      pageTitle: new FilterBuilderString(mk_prefix('pageTitle', prefix)),
      descriptionTitle: new FilterBuilderString(mk_prefix('descriptionTitle', prefix)),
      description: new FilterBuilderString(mk_prefix('description', prefix)),
    
  }
}


const ProductHeaderRelationBuilder: RelationBuilder<RelationsOf<ProductHeader>> = {

}


const  ProductHeaderParser : EntityParser<ProductHeader>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      pageTitle: parseNullString,
      descriptionTitle: parseNullString,
      description: parseNullString,
  
}


const ProductHeaderOrderBy : (p: string) => OrderByBuilderComplex<ProductHeader> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      pageTitle:  new OrderByProp(p ? p + "/pageTitle" : "pageTitle"),
      descriptionTitle:  new OrderByProp(p ? p + "/descriptionTitle" : "descriptionTitle"),
      description:  new OrderByProp(p ? p + "/description" : "description"),
  
})



export type Property = {
    Id: number
    CreatedDate: Date
    name: string | null
    value: string | null
    kind: string | null
} & {
  GlobalProduct_Property: List<GlobalProduct_Property>
    LocalizedPropertyGroup_Property: List<LocalizedPropertyGroup_Property>
    SubsidiaryProduct_Property: List<SubsidiaryProduct_Property>
}


function FilterBuilderProperty(prefix?: string) : FilterBuilderComplex<Property> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      name: new FilterBuilderString(mk_prefix('name', prefix)),
      value: new FilterBuilderString(mk_prefix('value', prefix)),
      kind: new FilterBuilderString(mk_prefix('kind', prefix)),
    GlobalProduct_Property: new FilterBuilderCollection<GlobalProduct_Property>(mk_prefix('GlobalProduct_Property', prefix), s => FilterBuilderGlobalProduct_Property(s)),
      LocalizedPropertyGroup_Property: new FilterBuilderCollection<LocalizedPropertyGroup_Property>(mk_prefix('LocalizedPropertyGroup_Property', prefix), s => FilterBuilderLocalizedPropertyGroup_Property(s)),
      SubsidiaryProduct_Property: new FilterBuilderCollection<SubsidiaryProduct_Property>(mk_prefix('SubsidiaryProduct_Property', prefix), s => FilterBuilderSubsidiaryProduct_Property(s)),
  }
}


const PropertyRelationBuilder: RelationBuilder<RelationsOf<Property>> = {
GlobalProduct_Property: () => mk_rel_query(
    'GlobalProduct_Property',
    FilterBuilderGlobalProduct_Property(),
    GlobalProduct_PropertyRelationBuilder,
    GlobalProduct_PropertyParser
  ),

LocalizedPropertyGroup_Property: () => mk_rel_query(
    'LocalizedPropertyGroup_Property',
    FilterBuilderLocalizedPropertyGroup_Property(),
    LocalizedPropertyGroup_PropertyRelationBuilder,
    LocalizedPropertyGroup_PropertyParser
  ),

SubsidiaryProduct_Property: () => mk_rel_query(
    'SubsidiaryProduct_Property',
    FilterBuilderSubsidiaryProduct_Property(),
    SubsidiaryProduct_PropertyRelationBuilder,
    SubsidiaryProduct_PropertyParser
  ),

}


const  PropertyParser : EntityParser<Property>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      name: parseNullString,
      value: parseNullString,
      kind: parseNullString,
  GlobalProduct_Property: p => parseCollection(x => parseEntity(x, p)),
      LocalizedPropertyGroup_Property: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct_Property: p => parseCollection(x => parseEntity(x, p)),
}


const PropertyOrderBy : (p: string) => OrderByBuilderComplex<Property> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      name:  new OrderByProp(p ? p + "/name" : "name"),
      value:  new OrderByProp(p ? p + "/value" : "value"),
      kind:  new OrderByProp(p ? p + "/kind" : "kind"),
  GlobalProduct_Property:  p => GlobalProduct_PropertyOrderBy(p ? p + "/GlobalProduct_Property" : "GlobalProduct_Property"),
      LocalizedPropertyGroup_Property:  p => LocalizedPropertyGroup_PropertyOrderBy(p ? p + "/LocalizedPropertyGroup_Property" : "LocalizedPropertyGroup_Property"),
      SubsidiaryProduct_Property:  p => SubsidiaryProduct_PropertyOrderBy(p ? p + "/SubsidiaryProduct_Property" : "SubsidiaryProduct_Property"),
})



export type Session = {
    Id: number
    LoggedEntityId: number | null
    LoggedEntityName: string | null
    AdditionalInfo: string | null
    CookieName: string | null
    Content: string | null
    CreatedAt: Date
    LastInteraction: Date
} & {

}


function FilterBuilderSession(prefix?: string) : FilterBuilderComplex<Session> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LoggedEntityId: new FilterBuilderNumber(mk_prefix('LoggedEntityId', prefix)),
      LoggedEntityName: new FilterBuilderString(mk_prefix('LoggedEntityName', prefix)),
      AdditionalInfo: new FilterBuilderString(mk_prefix('AdditionalInfo', prefix)),
      CookieName: new FilterBuilderString(mk_prefix('CookieName', prefix)),
      Content: new FilterBuilderString(mk_prefix('Content', prefix)),
      CreatedAt: new FilterBuilderDate(mk_prefix('CreatedAt', prefix)),
      LastInteraction: new FilterBuilderDate(mk_prefix('LastInteraction', prefix)),
    
  }
}


const SessionRelationBuilder: RelationBuilder<RelationsOf<Session>> = {

}


const  SessionParser : EntityParser<Session>= {
  Id: parseNumber,
      LoggedEntityId: parseNullNumber,
      LoggedEntityName: parseNullString,
      AdditionalInfo: parseNullString,
      CookieName: parseNullString,
      Content: parseNullString,
      CreatedAt: parseDate,
      LastInteraction: parseDate,
  
}


const SessionOrderBy : (p: string) => OrderByBuilderComplex<Session> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LoggedEntityId:  new OrderByProp(p ? p + "/LoggedEntityId" : "LoggedEntityId"),
      LoggedEntityName:  new OrderByProp(p ? p + "/LoggedEntityName" : "LoggedEntityName"),
      AdditionalInfo:  new OrderByProp(p ? p + "/AdditionalInfo" : "AdditionalInfo"),
      CookieName:  new OrderByProp(p ? p + "/CookieName" : "CookieName"),
      Content:  new OrderByProp(p ? p + "/Content" : "Content"),
      CreatedAt:  new OrderByProp(p ? p + "/CreatedAt" : "CreatedAt"),
      LastInteraction:  new OrderByProp(p ? p + "/LastInteraction" : "LastInteraction"),
  
})



export type Subsidiary = {
    Id: number
    CreatedDate: Date
    name: string | null
} & {
  Subsidiary_Locale: List<Subsidiary_Locale>
    Subsidiary_SubsidiaryProduct: List<Subsidiary_SubsidiaryProduct>
    Subsidiary_SubsidiaryProductManager: List<Subsidiary_SubsidiaryProductManager>
}


function FilterBuilderSubsidiary(prefix?: string) : FilterBuilderComplex<Subsidiary> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      name: new FilterBuilderString(mk_prefix('name', prefix)),
    Subsidiary_Locale: new FilterBuilderCollection<Subsidiary_Locale>(mk_prefix('Subsidiary_Locale', prefix), s => FilterBuilderSubsidiary_Locale(s)),
      Subsidiary_SubsidiaryProduct: new FilterBuilderCollection<Subsidiary_SubsidiaryProduct>(mk_prefix('Subsidiary_SubsidiaryProduct', prefix), s => FilterBuilderSubsidiary_SubsidiaryProduct(s)),
      Subsidiary_SubsidiaryProductManager: new FilterBuilderCollection<Subsidiary_SubsidiaryProductManager>(mk_prefix('Subsidiary_SubsidiaryProductManager', prefix), s => FilterBuilderSubsidiary_SubsidiaryProductManager(s)),
  }
}


const SubsidiaryRelationBuilder: RelationBuilder<RelationsOf<Subsidiary>> = {
Subsidiary_Locale: () => mk_rel_query(
    'Subsidiary_Locale',
    FilterBuilderSubsidiary_Locale(),
    Subsidiary_LocaleRelationBuilder,
    Subsidiary_LocaleParser
  ),

Subsidiary_SubsidiaryProduct: () => mk_rel_query(
    'Subsidiary_SubsidiaryProduct',
    FilterBuilderSubsidiary_SubsidiaryProduct(),
    Subsidiary_SubsidiaryProductRelationBuilder,
    Subsidiary_SubsidiaryProductParser
  ),

Subsidiary_SubsidiaryProductManager: () => mk_rel_query(
    'Subsidiary_SubsidiaryProductManager',
    FilterBuilderSubsidiary_SubsidiaryProductManager(),
    Subsidiary_SubsidiaryProductManagerRelationBuilder,
    Subsidiary_SubsidiaryProductManagerParser
  ),

}


const  SubsidiaryParser : EntityParser<Subsidiary>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      name: parseNullString,
  Subsidiary_Locale: p => parseCollection(x => parseEntity(x, p)),
      Subsidiary_SubsidiaryProduct: p => parseCollection(x => parseEntity(x, p)),
      Subsidiary_SubsidiaryProductManager: p => parseCollection(x => parseEntity(x, p)),
}


const SubsidiaryOrderBy : (p: string) => OrderByBuilderComplex<Subsidiary> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      name:  new OrderByProp(p ? p + "/name" : "name"),
  Subsidiary_Locale:  p => Subsidiary_LocaleOrderBy(p ? p + "/Subsidiary_Locale" : "Subsidiary_Locale"),
      Subsidiary_SubsidiaryProduct:  p => Subsidiary_SubsidiaryProductOrderBy(p ? p + "/Subsidiary_SubsidiaryProduct" : "Subsidiary_SubsidiaryProduct"),
      Subsidiary_SubsidiaryProductManager:  p => Subsidiary_SubsidiaryProductManagerOrderBy(p ? p + "/Subsidiary_SubsidiaryProductManager" : "Subsidiary_SubsidiaryProductManager"),
})



export type SubsidiaryProduct = {
    Id: number
    CreatedDate: Date
    kind: string | null
    name: string | null
    image: string | null
    hasBIM: boolean
    hasTechnicalDrawing: boolean
} & {
  SubsidiaryProduct_LocalizedProductHeader: List<SubsidiaryProduct_LocalizedProductHeader>
    SubsidiaryProduct_LocalizedPropertyGroup: List<SubsidiaryProduct_LocalizedPropertyGroup>
    SubsidiaryProduct_Property: List<SubsidiaryProduct_Property>
    SubsidiaryProduct_UnLocalizedProductHeader: List<SubsidiaryProduct_UnLocalizedProductHeader>
    Subsidiary_SubsidiaryProduct: List<Subsidiary_SubsidiaryProduct>
}


function FilterBuilderSubsidiaryProduct(prefix?: string) : FilterBuilderComplex<SubsidiaryProduct> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      kind: new FilterBuilderString(mk_prefix('kind', prefix)),
      name: new FilterBuilderString(mk_prefix('name', prefix)),
      image: new FilterBuilderString(mk_prefix('image', prefix)),
      hasBIM: new FilterBuilderBoolean(mk_prefix('hasBIM', prefix)),
      hasTechnicalDrawing: new FilterBuilderBoolean(mk_prefix('hasTechnicalDrawing', prefix)),
    SubsidiaryProduct_LocalizedProductHeader: new FilterBuilderCollection<SubsidiaryProduct_LocalizedProductHeader>(mk_prefix('SubsidiaryProduct_LocalizedProductHeader', prefix), s => FilterBuilderSubsidiaryProduct_LocalizedProductHeader(s)),
      SubsidiaryProduct_LocalizedPropertyGroup: new FilterBuilderCollection<SubsidiaryProduct_LocalizedPropertyGroup>(mk_prefix('SubsidiaryProduct_LocalizedPropertyGroup', prefix), s => FilterBuilderSubsidiaryProduct_LocalizedPropertyGroup(s)),
      SubsidiaryProduct_Property: new FilterBuilderCollection<SubsidiaryProduct_Property>(mk_prefix('SubsidiaryProduct_Property', prefix), s => FilterBuilderSubsidiaryProduct_Property(s)),
      SubsidiaryProduct_UnLocalizedProductHeader: new FilterBuilderCollection<SubsidiaryProduct_UnLocalizedProductHeader>(mk_prefix('SubsidiaryProduct_UnLocalizedProductHeader', prefix), s => FilterBuilderSubsidiaryProduct_UnLocalizedProductHeader(s)),
      Subsidiary_SubsidiaryProduct: new FilterBuilderCollection<Subsidiary_SubsidiaryProduct>(mk_prefix('Subsidiary_SubsidiaryProduct', prefix), s => FilterBuilderSubsidiary_SubsidiaryProduct(s)),
  }
}


const SubsidiaryProductRelationBuilder: RelationBuilder<RelationsOf<SubsidiaryProduct>> = {
SubsidiaryProduct_LocalizedProductHeader: () => mk_rel_query(
    'SubsidiaryProduct_LocalizedProductHeader',
    FilterBuilderSubsidiaryProduct_LocalizedProductHeader(),
    SubsidiaryProduct_LocalizedProductHeaderRelationBuilder,
    SubsidiaryProduct_LocalizedProductHeaderParser
  ),

SubsidiaryProduct_LocalizedPropertyGroup: () => mk_rel_query(
    'SubsidiaryProduct_LocalizedPropertyGroup',
    FilterBuilderSubsidiaryProduct_LocalizedPropertyGroup(),
    SubsidiaryProduct_LocalizedPropertyGroupRelationBuilder,
    SubsidiaryProduct_LocalizedPropertyGroupParser
  ),

SubsidiaryProduct_Property: () => mk_rel_query(
    'SubsidiaryProduct_Property',
    FilterBuilderSubsidiaryProduct_Property(),
    SubsidiaryProduct_PropertyRelationBuilder,
    SubsidiaryProduct_PropertyParser
  ),

SubsidiaryProduct_UnLocalizedProductHeader: () => mk_rel_query(
    'SubsidiaryProduct_UnLocalizedProductHeader',
    FilterBuilderSubsidiaryProduct_UnLocalizedProductHeader(),
    SubsidiaryProduct_UnLocalizedProductHeaderRelationBuilder,
    SubsidiaryProduct_UnLocalizedProductHeaderParser
  ),

Subsidiary_SubsidiaryProduct: () => mk_rel_query(
    'Subsidiary_SubsidiaryProduct',
    FilterBuilderSubsidiary_SubsidiaryProduct(),
    Subsidiary_SubsidiaryProductRelationBuilder,
    Subsidiary_SubsidiaryProductParser
  ),

}


const  SubsidiaryProductParser : EntityParser<SubsidiaryProduct>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      kind: parseNullString,
      name: parseNullString,
      image: parseNullString,
      hasBIM: parseBoolean,
      hasTechnicalDrawing: parseBoolean,
  SubsidiaryProduct_LocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct_LocalizedPropertyGroup: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct_Property: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct_UnLocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      Subsidiary_SubsidiaryProduct: p => parseCollection(x => parseEntity(x, p)),
}


const SubsidiaryProductOrderBy : (p: string) => OrderByBuilderComplex<SubsidiaryProduct> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      kind:  new OrderByProp(p ? p + "/kind" : "kind"),
      name:  new OrderByProp(p ? p + "/name" : "name"),
      image:  new OrderByProp(p ? p + "/image" : "image"),
      hasBIM:  new OrderByProp(p ? p + "/hasBIM" : "hasBIM"),
      hasTechnicalDrawing:  new OrderByProp(p ? p + "/hasTechnicalDrawing" : "hasTechnicalDrawing"),
  SubsidiaryProduct_LocalizedProductHeader:  p => SubsidiaryProduct_LocalizedProductHeaderOrderBy(p ? p + "/SubsidiaryProduct_LocalizedProductHeader" : "SubsidiaryProduct_LocalizedProductHeader"),
      SubsidiaryProduct_LocalizedPropertyGroup:  p => SubsidiaryProduct_LocalizedPropertyGroupOrderBy(p ? p + "/SubsidiaryProduct_LocalizedPropertyGroup" : "SubsidiaryProduct_LocalizedPropertyGroup"),
      SubsidiaryProduct_Property:  p => SubsidiaryProduct_PropertyOrderBy(p ? p + "/SubsidiaryProduct_Property" : "SubsidiaryProduct_Property"),
      SubsidiaryProduct_UnLocalizedProductHeader:  p => SubsidiaryProduct_UnLocalizedProductHeaderOrderBy(p ? p + "/SubsidiaryProduct_UnLocalizedProductHeader" : "SubsidiaryProduct_UnLocalizedProductHeader"),
      Subsidiary_SubsidiaryProduct:  p => Subsidiary_SubsidiaryProductOrderBy(p ? p + "/Subsidiary_SubsidiaryProduct" : "Subsidiary_SubsidiaryProduct"),
})



export type SubsidiaryProductManager = {
    Id: number
    CreatedDate: Date
    Username: string | null
    Email: string | null
    Language: string | null
    PasswordHash: string | null
    PasswordSalt: string | null
    LastLoginAttempt: Date
    SecurityStamp: string | null
    EmailConfirmed: boolean
} & {
  Subsidiary_SubsidiaryProductManager: List<Subsidiary_SubsidiaryProductManager>
}


function FilterBuilderSubsidiaryProductManager(prefix?: string) : FilterBuilderComplex<SubsidiaryProductManager> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Username: new FilterBuilderString(mk_prefix('Username', prefix)),
      Email: new FilterBuilderString(mk_prefix('Email', prefix)),
      Language: new FilterBuilderString(mk_prefix('Language', prefix)),
      PasswordHash: new FilterBuilderString(mk_prefix('PasswordHash', prefix)),
      PasswordSalt: new FilterBuilderString(mk_prefix('PasswordSalt', prefix)),
      LastLoginAttempt: new FilterBuilderDate(mk_prefix('LastLoginAttempt', prefix)),
      SecurityStamp: new FilterBuilderString(mk_prefix('SecurityStamp', prefix)),
      EmailConfirmed: new FilterBuilderBoolean(mk_prefix('EmailConfirmed', prefix)),
    Subsidiary_SubsidiaryProductManager: new FilterBuilderCollection<Subsidiary_SubsidiaryProductManager>(mk_prefix('Subsidiary_SubsidiaryProductManager', prefix), s => FilterBuilderSubsidiary_SubsidiaryProductManager(s)),
  }
}


const SubsidiaryProductManagerRelationBuilder: RelationBuilder<RelationsOf<SubsidiaryProductManager>> = {
Subsidiary_SubsidiaryProductManager: () => mk_rel_query(
    'Subsidiary_SubsidiaryProductManager',
    FilterBuilderSubsidiary_SubsidiaryProductManager(),
    Subsidiary_SubsidiaryProductManagerRelationBuilder,
    Subsidiary_SubsidiaryProductManagerParser
  ),

}


const  SubsidiaryProductManagerParser : EntityParser<SubsidiaryProductManager>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Username: parseNullString,
      Email: parseNullString,
      Language: parseNullString,
      PasswordHash: parseNullString,
      PasswordSalt: parseNullString,
      LastLoginAttempt: parseDate,
      SecurityStamp: parseNullString,
      EmailConfirmed: parseBoolean,
  Subsidiary_SubsidiaryProductManager: p => parseCollection(x => parseEntity(x, p)),
}


const SubsidiaryProductManagerOrderBy : (p: string) => OrderByBuilderComplex<SubsidiaryProductManager> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Username:  new OrderByProp(p ? p + "/Username" : "Username"),
      Email:  new OrderByProp(p ? p + "/Email" : "Email"),
      Language:  new OrderByProp(p ? p + "/Language" : "Language"),
      PasswordHash:  new OrderByProp(p ? p + "/PasswordHash" : "PasswordHash"),
      PasswordSalt:  new OrderByProp(p ? p + "/PasswordSalt" : "PasswordSalt"),
      LastLoginAttempt:  new OrderByProp(p ? p + "/LastLoginAttempt" : "LastLoginAttempt"),
      SecurityStamp:  new OrderByProp(p ? p + "/SecurityStamp" : "SecurityStamp"),
      EmailConfirmed:  new OrderByProp(p ? p + "/EmailConfirmed" : "EmailConfirmed"),
  Subsidiary_SubsidiaryProductManager:  p => Subsidiary_SubsidiaryProductManagerOrderBy(p ? p + "/Subsidiary_SubsidiaryProductManager" : "Subsidiary_SubsidiaryProductManager"),
})



export type SubsidiaryProduct_LocalizedProductHeader = {
    Id: number
    SubsidiaryProductId: number
    LocalizedProductHeaderId: number
} & {
  LocalizedProductHeader: List<LocalizedProductHeader>
    SubsidiaryProduct: List<SubsidiaryProduct>
}


function FilterBuilderSubsidiaryProduct_LocalizedProductHeader(prefix?: string) : FilterBuilderComplex<SubsidiaryProduct_LocalizedProductHeader> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      SubsidiaryProductId: new FilterBuilderNumber(mk_prefix('SubsidiaryProductId', prefix)),
      LocalizedProductHeaderId: new FilterBuilderNumber(mk_prefix('LocalizedProductHeaderId', prefix)),
    LocalizedProductHeader: new FilterBuilderCollection<LocalizedProductHeader>(mk_prefix('LocalizedProductHeader', prefix), s => FilterBuilderLocalizedProductHeader(s)),
      SubsidiaryProduct: new FilterBuilderCollection<SubsidiaryProduct>(mk_prefix('SubsidiaryProduct', prefix), s => FilterBuilderSubsidiaryProduct(s)),
  }
}


const SubsidiaryProduct_LocalizedProductHeaderRelationBuilder: RelationBuilder<RelationsOf<SubsidiaryProduct_LocalizedProductHeader>> = {
LocalizedProductHeader: () => mk_rel_query(
    'LocalizedProductHeader',
    FilterBuilderLocalizedProductHeader(),
    LocalizedProductHeaderRelationBuilder,
    LocalizedProductHeaderParser
  ),

SubsidiaryProduct: () => mk_rel_query(
    'SubsidiaryProduct',
    FilterBuilderSubsidiaryProduct(),
    SubsidiaryProductRelationBuilder,
    SubsidiaryProductParser
  ),

}


const  SubsidiaryProduct_LocalizedProductHeaderParser : EntityParser<SubsidiaryProduct_LocalizedProductHeader>= {
  Id: parseNumber,
      SubsidiaryProductId: parseNumber,
      LocalizedProductHeaderId: parseNumber,
  LocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct: p => parseCollection(x => parseEntity(x, p)),
}


const SubsidiaryProduct_LocalizedProductHeaderOrderBy : (p: string) => OrderByBuilderComplex<SubsidiaryProduct_LocalizedProductHeader> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      SubsidiaryProductId:  new OrderByProp(p ? p + "/SubsidiaryProductId" : "SubsidiaryProductId"),
      LocalizedProductHeaderId:  new OrderByProp(p ? p + "/LocalizedProductHeaderId" : "LocalizedProductHeaderId"),
  LocalizedProductHeader:  p => LocalizedProductHeaderOrderBy(p ? p + "/LocalizedProductHeader" : "LocalizedProductHeader"),
      SubsidiaryProduct:  p => SubsidiaryProductOrderBy(p ? p + "/SubsidiaryProduct" : "SubsidiaryProduct"),
})



export type SubsidiaryProduct_LocalizedPropertyGroup = {
    Id: number
    SubsidiaryProductId: number
    LocalizedPropertyGroupId: number
} & {
  LocalizedPropertyGroup: List<LocalizedPropertyGroup>
    SubsidiaryProduct: List<SubsidiaryProduct>
}


function FilterBuilderSubsidiaryProduct_LocalizedPropertyGroup(prefix?: string) : FilterBuilderComplex<SubsidiaryProduct_LocalizedPropertyGroup> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      SubsidiaryProductId: new FilterBuilderNumber(mk_prefix('SubsidiaryProductId', prefix)),
      LocalizedPropertyGroupId: new FilterBuilderNumber(mk_prefix('LocalizedPropertyGroupId', prefix)),
    LocalizedPropertyGroup: new FilterBuilderCollection<LocalizedPropertyGroup>(mk_prefix('LocalizedPropertyGroup', prefix), s => FilterBuilderLocalizedPropertyGroup(s)),
      SubsidiaryProduct: new FilterBuilderCollection<SubsidiaryProduct>(mk_prefix('SubsidiaryProduct', prefix), s => FilterBuilderSubsidiaryProduct(s)),
  }
}


const SubsidiaryProduct_LocalizedPropertyGroupRelationBuilder: RelationBuilder<RelationsOf<SubsidiaryProduct_LocalizedPropertyGroup>> = {
LocalizedPropertyGroup: () => mk_rel_query(
    'LocalizedPropertyGroup',
    FilterBuilderLocalizedPropertyGroup(),
    LocalizedPropertyGroupRelationBuilder,
    LocalizedPropertyGroupParser
  ),

SubsidiaryProduct: () => mk_rel_query(
    'SubsidiaryProduct',
    FilterBuilderSubsidiaryProduct(),
    SubsidiaryProductRelationBuilder,
    SubsidiaryProductParser
  ),

}


const  SubsidiaryProduct_LocalizedPropertyGroupParser : EntityParser<SubsidiaryProduct_LocalizedPropertyGroup>= {
  Id: parseNumber,
      SubsidiaryProductId: parseNumber,
      LocalizedPropertyGroupId: parseNumber,
  LocalizedPropertyGroup: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct: p => parseCollection(x => parseEntity(x, p)),
}


const SubsidiaryProduct_LocalizedPropertyGroupOrderBy : (p: string) => OrderByBuilderComplex<SubsidiaryProduct_LocalizedPropertyGroup> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      SubsidiaryProductId:  new OrderByProp(p ? p + "/SubsidiaryProductId" : "SubsidiaryProductId"),
      LocalizedPropertyGroupId:  new OrderByProp(p ? p + "/LocalizedPropertyGroupId" : "LocalizedPropertyGroupId"),
  LocalizedPropertyGroup:  p => LocalizedPropertyGroupOrderBy(p ? p + "/LocalizedPropertyGroup" : "LocalizedPropertyGroup"),
      SubsidiaryProduct:  p => SubsidiaryProductOrderBy(p ? p + "/SubsidiaryProduct" : "SubsidiaryProduct"),
})



export type SubsidiaryProduct_Property = {
    Id: number
    SubsidiaryProductId: number
    PropertyId: number
} & {
  Property: List<Property>
    SubsidiaryProduct: List<SubsidiaryProduct>
}


function FilterBuilderSubsidiaryProduct_Property(prefix?: string) : FilterBuilderComplex<SubsidiaryProduct_Property> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      SubsidiaryProductId: new FilterBuilderNumber(mk_prefix('SubsidiaryProductId', prefix)),
      PropertyId: new FilterBuilderNumber(mk_prefix('PropertyId', prefix)),
    Property: new FilterBuilderCollection<Property>(mk_prefix('Property', prefix), s => FilterBuilderProperty(s)),
      SubsidiaryProduct: new FilterBuilderCollection<SubsidiaryProduct>(mk_prefix('SubsidiaryProduct', prefix), s => FilterBuilderSubsidiaryProduct(s)),
  }
}


const SubsidiaryProduct_PropertyRelationBuilder: RelationBuilder<RelationsOf<SubsidiaryProduct_Property>> = {
Property: () => mk_rel_query(
    'Property',
    FilterBuilderProperty(),
    PropertyRelationBuilder,
    PropertyParser
  ),

SubsidiaryProduct: () => mk_rel_query(
    'SubsidiaryProduct',
    FilterBuilderSubsidiaryProduct(),
    SubsidiaryProductRelationBuilder,
    SubsidiaryProductParser
  ),

}


const  SubsidiaryProduct_PropertyParser : EntityParser<SubsidiaryProduct_Property>= {
  Id: parseNumber,
      SubsidiaryProductId: parseNumber,
      PropertyId: parseNumber,
  Property: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct: p => parseCollection(x => parseEntity(x, p)),
}


const SubsidiaryProduct_PropertyOrderBy : (p: string) => OrderByBuilderComplex<SubsidiaryProduct_Property> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      SubsidiaryProductId:  new OrderByProp(p ? p + "/SubsidiaryProductId" : "SubsidiaryProductId"),
      PropertyId:  new OrderByProp(p ? p + "/PropertyId" : "PropertyId"),
  Property:  p => PropertyOrderBy(p ? p + "/Property" : "Property"),
      SubsidiaryProduct:  p => SubsidiaryProductOrderBy(p ? p + "/SubsidiaryProduct" : "SubsidiaryProduct"),
})



export type SubsidiaryProduct_UnLocalizedProductHeader = {
    Id: number
    SubsidiaryProductId: number
    UnLocalizedProductHeaderId: number
} & {
  SubsidiaryProduct: List<SubsidiaryProduct>
    UnLocalizedProductHeader: List<UnLocalizedProductHeader>
}


function FilterBuilderSubsidiaryProduct_UnLocalizedProductHeader(prefix?: string) : FilterBuilderComplex<SubsidiaryProduct_UnLocalizedProductHeader> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      SubsidiaryProductId: new FilterBuilderNumber(mk_prefix('SubsidiaryProductId', prefix)),
      UnLocalizedProductHeaderId: new FilterBuilderNumber(mk_prefix('UnLocalizedProductHeaderId', prefix)),
    SubsidiaryProduct: new FilterBuilderCollection<SubsidiaryProduct>(mk_prefix('SubsidiaryProduct', prefix), s => FilterBuilderSubsidiaryProduct(s)),
      UnLocalizedProductHeader: new FilterBuilderCollection<UnLocalizedProductHeader>(mk_prefix('UnLocalizedProductHeader', prefix), s => FilterBuilderUnLocalizedProductHeader(s)),
  }
}


const SubsidiaryProduct_UnLocalizedProductHeaderRelationBuilder: RelationBuilder<RelationsOf<SubsidiaryProduct_UnLocalizedProductHeader>> = {
SubsidiaryProduct: () => mk_rel_query(
    'SubsidiaryProduct',
    FilterBuilderSubsidiaryProduct(),
    SubsidiaryProductRelationBuilder,
    SubsidiaryProductParser
  ),

UnLocalizedProductHeader: () => mk_rel_query(
    'UnLocalizedProductHeader',
    FilterBuilderUnLocalizedProductHeader(),
    UnLocalizedProductHeaderRelationBuilder,
    UnLocalizedProductHeaderParser
  ),

}


const  SubsidiaryProduct_UnLocalizedProductHeaderParser : EntityParser<SubsidiaryProduct_UnLocalizedProductHeader>= {
  Id: parseNumber,
      SubsidiaryProductId: parseNumber,
      UnLocalizedProductHeaderId: parseNumber,
  SubsidiaryProduct: p => parseCollection(x => parseEntity(x, p)),
      UnLocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
}


const SubsidiaryProduct_UnLocalizedProductHeaderOrderBy : (p: string) => OrderByBuilderComplex<SubsidiaryProduct_UnLocalizedProductHeader> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      SubsidiaryProductId:  new OrderByProp(p ? p + "/SubsidiaryProductId" : "SubsidiaryProductId"),
      UnLocalizedProductHeaderId:  new OrderByProp(p ? p + "/UnLocalizedProductHeaderId" : "UnLocalizedProductHeaderId"),
  SubsidiaryProduct:  p => SubsidiaryProductOrderBy(p ? p + "/SubsidiaryProduct" : "SubsidiaryProduct"),
      UnLocalizedProductHeader:  p => UnLocalizedProductHeaderOrderBy(p ? p + "/UnLocalizedProductHeader" : "UnLocalizedProductHeader"),
})



export type Subsidiary_Locale = {
    Id: number
    SubsidiaryId: number
    LocaleId: number
} & {
  Locale: List<Locale>
    Subsidiary: List<Subsidiary>
}


function FilterBuilderSubsidiary_Locale(prefix?: string) : FilterBuilderComplex<Subsidiary_Locale> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      SubsidiaryId: new FilterBuilderNumber(mk_prefix('SubsidiaryId', prefix)),
      LocaleId: new FilterBuilderNumber(mk_prefix('LocaleId', prefix)),
    Locale: new FilterBuilderCollection<Locale>(mk_prefix('Locale', prefix), s => FilterBuilderLocale(s)),
      Subsidiary: new FilterBuilderCollection<Subsidiary>(mk_prefix('Subsidiary', prefix), s => FilterBuilderSubsidiary(s)),
  }
}


const Subsidiary_LocaleRelationBuilder: RelationBuilder<RelationsOf<Subsidiary_Locale>> = {
Locale: () => mk_rel_query(
    'Locale',
    FilterBuilderLocale(),
    LocaleRelationBuilder,
    LocaleParser
  ),

Subsidiary: () => mk_rel_query(
    'Subsidiary',
    FilterBuilderSubsidiary(),
    SubsidiaryRelationBuilder,
    SubsidiaryParser
  ),

}


const  Subsidiary_LocaleParser : EntityParser<Subsidiary_Locale>= {
  Id: parseNumber,
      SubsidiaryId: parseNumber,
      LocaleId: parseNumber,
  Locale: p => parseCollection(x => parseEntity(x, p)),
      Subsidiary: p => parseCollection(x => parseEntity(x, p)),
}


const Subsidiary_LocaleOrderBy : (p: string) => OrderByBuilderComplex<Subsidiary_Locale> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      SubsidiaryId:  new OrderByProp(p ? p + "/SubsidiaryId" : "SubsidiaryId"),
      LocaleId:  new OrderByProp(p ? p + "/LocaleId" : "LocaleId"),
  Locale:  p => LocaleOrderBy(p ? p + "/Locale" : "Locale"),
      Subsidiary:  p => SubsidiaryOrderBy(p ? p + "/Subsidiary" : "Subsidiary"),
})



export type Subsidiary_SubsidiaryProduct = {
    Id: number
    SubsidiaryId: number
    SubsidiaryProductId: number
} & {
  Subsidiary: List<Subsidiary>
    SubsidiaryProduct: List<SubsidiaryProduct>
}


function FilterBuilderSubsidiary_SubsidiaryProduct(prefix?: string) : FilterBuilderComplex<Subsidiary_SubsidiaryProduct> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      SubsidiaryId: new FilterBuilderNumber(mk_prefix('SubsidiaryId', prefix)),
      SubsidiaryProductId: new FilterBuilderNumber(mk_prefix('SubsidiaryProductId', prefix)),
    Subsidiary: new FilterBuilderCollection<Subsidiary>(mk_prefix('Subsidiary', prefix), s => FilterBuilderSubsidiary(s)),
      SubsidiaryProduct: new FilterBuilderCollection<SubsidiaryProduct>(mk_prefix('SubsidiaryProduct', prefix), s => FilterBuilderSubsidiaryProduct(s)),
  }
}


const Subsidiary_SubsidiaryProductRelationBuilder: RelationBuilder<RelationsOf<Subsidiary_SubsidiaryProduct>> = {
Subsidiary: () => mk_rel_query(
    'Subsidiary',
    FilterBuilderSubsidiary(),
    SubsidiaryRelationBuilder,
    SubsidiaryParser
  ),

SubsidiaryProduct: () => mk_rel_query(
    'SubsidiaryProduct',
    FilterBuilderSubsidiaryProduct(),
    SubsidiaryProductRelationBuilder,
    SubsidiaryProductParser
  ),

}


const  Subsidiary_SubsidiaryProductParser : EntityParser<Subsidiary_SubsidiaryProduct>= {
  Id: parseNumber,
      SubsidiaryId: parseNumber,
      SubsidiaryProductId: parseNumber,
  Subsidiary: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct: p => parseCollection(x => parseEntity(x, p)),
}


const Subsidiary_SubsidiaryProductOrderBy : (p: string) => OrderByBuilderComplex<Subsidiary_SubsidiaryProduct> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      SubsidiaryId:  new OrderByProp(p ? p + "/SubsidiaryId" : "SubsidiaryId"),
      SubsidiaryProductId:  new OrderByProp(p ? p + "/SubsidiaryProductId" : "SubsidiaryProductId"),
  Subsidiary:  p => SubsidiaryOrderBy(p ? p + "/Subsidiary" : "Subsidiary"),
      SubsidiaryProduct:  p => SubsidiaryProductOrderBy(p ? p + "/SubsidiaryProduct" : "SubsidiaryProduct"),
})



export type Subsidiary_SubsidiaryProductManager = {
    Id: number
    SubsidiaryId: number
    SubsidiaryProductManagerId: number
} & {
  Subsidiary: List<Subsidiary>
    SubsidiaryProductManager: List<SubsidiaryProductManager>
}


function FilterBuilderSubsidiary_SubsidiaryProductManager(prefix?: string) : FilterBuilderComplex<Subsidiary_SubsidiaryProductManager> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      SubsidiaryId: new FilterBuilderNumber(mk_prefix('SubsidiaryId', prefix)),
      SubsidiaryProductManagerId: new FilterBuilderNumber(mk_prefix('SubsidiaryProductManagerId', prefix)),
    Subsidiary: new FilterBuilderCollection<Subsidiary>(mk_prefix('Subsidiary', prefix), s => FilterBuilderSubsidiary(s)),
      SubsidiaryProductManager: new FilterBuilderCollection<SubsidiaryProductManager>(mk_prefix('SubsidiaryProductManager', prefix), s => FilterBuilderSubsidiaryProductManager(s)),
  }
}


const Subsidiary_SubsidiaryProductManagerRelationBuilder: RelationBuilder<RelationsOf<Subsidiary_SubsidiaryProductManager>> = {
Subsidiary: () => mk_rel_query(
    'Subsidiary',
    FilterBuilderSubsidiary(),
    SubsidiaryRelationBuilder,
    SubsidiaryParser
  ),

SubsidiaryProductManager: () => mk_rel_query(
    'SubsidiaryProductManager',
    FilterBuilderSubsidiaryProductManager(),
    SubsidiaryProductManagerRelationBuilder,
    SubsidiaryProductManagerParser
  ),

}


const  Subsidiary_SubsidiaryProductManagerParser : EntityParser<Subsidiary_SubsidiaryProductManager>= {
  Id: parseNumber,
      SubsidiaryId: parseNumber,
      SubsidiaryProductManagerId: parseNumber,
  Subsidiary: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProductManager: p => parseCollection(x => parseEntity(x, p)),
}


const Subsidiary_SubsidiaryProductManagerOrderBy : (p: string) => OrderByBuilderComplex<Subsidiary_SubsidiaryProductManager> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      SubsidiaryId:  new OrderByProp(p ? p + "/SubsidiaryId" : "SubsidiaryId"),
      SubsidiaryProductManagerId:  new OrderByProp(p ? p + "/SubsidiaryProductManagerId" : "SubsidiaryProductManagerId"),
  Subsidiary:  p => SubsidiaryOrderBy(p ? p + "/Subsidiary" : "Subsidiary"),
      SubsidiaryProductManager:  p => SubsidiaryProductManagerOrderBy(p ? p + "/SubsidiaryProductManager" : "SubsidiaryProductManager"),
})



export type UnLocalizedProductHeader = {
    Id: number
    CreatedDate: Date
    pageTitle: string | null
    descriptionTitle: string | null
    description: string | null
} & {
  GlobalProduct_UnLocalizedProductHeader: List<GlobalProduct_UnLocalizedProductHeader>
    SubsidiaryProduct_UnLocalizedProductHeader: List<SubsidiaryProduct_UnLocalizedProductHeader>
    UnLocalizedProductHeader_Usp: List<UnLocalizedProductHeader_Usp>
}


function FilterBuilderUnLocalizedProductHeader(prefix?: string) : FilterBuilderComplex<UnLocalizedProductHeader> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      pageTitle: new FilterBuilderString(mk_prefix('pageTitle', prefix)),
      descriptionTitle: new FilterBuilderString(mk_prefix('descriptionTitle', prefix)),
      description: new FilterBuilderString(mk_prefix('description', prefix)),
    GlobalProduct_UnLocalizedProductHeader: new FilterBuilderCollection<GlobalProduct_UnLocalizedProductHeader>(mk_prefix('GlobalProduct_UnLocalizedProductHeader', prefix), s => FilterBuilderGlobalProduct_UnLocalizedProductHeader(s)),
      SubsidiaryProduct_UnLocalizedProductHeader: new FilterBuilderCollection<SubsidiaryProduct_UnLocalizedProductHeader>(mk_prefix('SubsidiaryProduct_UnLocalizedProductHeader', prefix), s => FilterBuilderSubsidiaryProduct_UnLocalizedProductHeader(s)),
      UnLocalizedProductHeader_Usp: new FilterBuilderCollection<UnLocalizedProductHeader_Usp>(mk_prefix('UnLocalizedProductHeader_Usp', prefix), s => FilterBuilderUnLocalizedProductHeader_Usp(s)),
  }
}


const UnLocalizedProductHeaderRelationBuilder: RelationBuilder<RelationsOf<UnLocalizedProductHeader>> = {
GlobalProduct_UnLocalizedProductHeader: () => mk_rel_query(
    'GlobalProduct_UnLocalizedProductHeader',
    FilterBuilderGlobalProduct_UnLocalizedProductHeader(),
    GlobalProduct_UnLocalizedProductHeaderRelationBuilder,
    GlobalProduct_UnLocalizedProductHeaderParser
  ),

SubsidiaryProduct_UnLocalizedProductHeader: () => mk_rel_query(
    'SubsidiaryProduct_UnLocalizedProductHeader',
    FilterBuilderSubsidiaryProduct_UnLocalizedProductHeader(),
    SubsidiaryProduct_UnLocalizedProductHeaderRelationBuilder,
    SubsidiaryProduct_UnLocalizedProductHeaderParser
  ),

UnLocalizedProductHeader_Usp: () => mk_rel_query(
    'UnLocalizedProductHeader_Usp',
    FilterBuilderUnLocalizedProductHeader_Usp(),
    UnLocalizedProductHeader_UspRelationBuilder,
    UnLocalizedProductHeader_UspParser
  ),

}


const  UnLocalizedProductHeaderParser : EntityParser<UnLocalizedProductHeader>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      pageTitle: parseNullString,
      descriptionTitle: parseNullString,
      description: parseNullString,
  GlobalProduct_UnLocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      SubsidiaryProduct_UnLocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      UnLocalizedProductHeader_Usp: p => parseCollection(x => parseEntity(x, p)),
}


const UnLocalizedProductHeaderOrderBy : (p: string) => OrderByBuilderComplex<UnLocalizedProductHeader> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      pageTitle:  new OrderByProp(p ? p + "/pageTitle" : "pageTitle"),
      descriptionTitle:  new OrderByProp(p ? p + "/descriptionTitle" : "descriptionTitle"),
      description:  new OrderByProp(p ? p + "/description" : "description"),
  GlobalProduct_UnLocalizedProductHeader:  p => GlobalProduct_UnLocalizedProductHeaderOrderBy(p ? p + "/GlobalProduct_UnLocalizedProductHeader" : "GlobalProduct_UnLocalizedProductHeader"),
      SubsidiaryProduct_UnLocalizedProductHeader:  p => SubsidiaryProduct_UnLocalizedProductHeaderOrderBy(p ? p + "/SubsidiaryProduct_UnLocalizedProductHeader" : "SubsidiaryProduct_UnLocalizedProductHeader"),
      UnLocalizedProductHeader_Usp:  p => UnLocalizedProductHeader_UspOrderBy(p ? p + "/UnLocalizedProductHeader_Usp" : "UnLocalizedProductHeader_Usp"),
})



export type UnLocalizedProductHeader_Usp = {
    Id: number
    UnLocalizedProductHeaderId: number
    UspId: number
} & {
  UnLocalizedProductHeader: List<UnLocalizedProductHeader>
    Usp: List<Usp>
}


function FilterBuilderUnLocalizedProductHeader_Usp(prefix?: string) : FilterBuilderComplex<UnLocalizedProductHeader_Usp> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      UnLocalizedProductHeaderId: new FilterBuilderNumber(mk_prefix('UnLocalizedProductHeaderId', prefix)),
      UspId: new FilterBuilderNumber(mk_prefix('UspId', prefix)),
    UnLocalizedProductHeader: new FilterBuilderCollection<UnLocalizedProductHeader>(mk_prefix('UnLocalizedProductHeader', prefix), s => FilterBuilderUnLocalizedProductHeader(s)),
      Usp: new FilterBuilderCollection<Usp>(mk_prefix('Usp', prefix), s => FilterBuilderUsp(s)),
  }
}


const UnLocalizedProductHeader_UspRelationBuilder: RelationBuilder<RelationsOf<UnLocalizedProductHeader_Usp>> = {
UnLocalizedProductHeader: () => mk_rel_query(
    'UnLocalizedProductHeader',
    FilterBuilderUnLocalizedProductHeader(),
    UnLocalizedProductHeaderRelationBuilder,
    UnLocalizedProductHeaderParser
  ),

Usp: () => mk_rel_query(
    'Usp',
    FilterBuilderUsp(),
    UspRelationBuilder,
    UspParser
  ),

}


const  UnLocalizedProductHeader_UspParser : EntityParser<UnLocalizedProductHeader_Usp>= {
  Id: parseNumber,
      UnLocalizedProductHeaderId: parseNumber,
      UspId: parseNumber,
  UnLocalizedProductHeader: p => parseCollection(x => parseEntity(x, p)),
      Usp: p => parseCollection(x => parseEntity(x, p)),
}


const UnLocalizedProductHeader_UspOrderBy : (p: string) => OrderByBuilderComplex<UnLocalizedProductHeader_Usp> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      UnLocalizedProductHeaderId:  new OrderByProp(p ? p + "/UnLocalizedProductHeaderId" : "UnLocalizedProductHeaderId"),
      UspId:  new OrderByProp(p ? p + "/UspId" : "UspId"),
  UnLocalizedProductHeader:  p => UnLocalizedProductHeaderOrderBy(p ? p + "/UnLocalizedProductHeader" : "UnLocalizedProductHeader"),
      Usp:  p => UspOrderBy(p ? p + "/Usp" : "Usp"),
})



export type Usp = {
    Id: number
    CreatedDate: Date
    value: string | null
} & {
  LocalizedProductHeader_Usp: List<LocalizedProductHeader_Usp>
    UnLocalizedProductHeader_Usp: List<UnLocalizedProductHeader_Usp>
}


function FilterBuilderUsp(prefix?: string) : FilterBuilderComplex<Usp> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      value: new FilterBuilderString(mk_prefix('value', prefix)),
    LocalizedProductHeader_Usp: new FilterBuilderCollection<LocalizedProductHeader_Usp>(mk_prefix('LocalizedProductHeader_Usp', prefix), s => FilterBuilderLocalizedProductHeader_Usp(s)),
      UnLocalizedProductHeader_Usp: new FilterBuilderCollection<UnLocalizedProductHeader_Usp>(mk_prefix('UnLocalizedProductHeader_Usp', prefix), s => FilterBuilderUnLocalizedProductHeader_Usp(s)),
  }
}


const UspRelationBuilder: RelationBuilder<RelationsOf<Usp>> = {
LocalizedProductHeader_Usp: () => mk_rel_query(
    'LocalizedProductHeader_Usp',
    FilterBuilderLocalizedProductHeader_Usp(),
    LocalizedProductHeader_UspRelationBuilder,
    LocalizedProductHeader_UspParser
  ),

UnLocalizedProductHeader_Usp: () => mk_rel_query(
    'UnLocalizedProductHeader_Usp',
    FilterBuilderUnLocalizedProductHeader_Usp(),
    UnLocalizedProductHeader_UspRelationBuilder,
    UnLocalizedProductHeader_UspParser
  ),

}


const  UspParser : EntityParser<Usp>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      value: parseNullString,
  LocalizedProductHeader_Usp: p => parseCollection(x => parseEntity(x, p)),
      UnLocalizedProductHeader_Usp: p => parseCollection(x => parseEntity(x, p)),
}


const UspOrderBy : (p: string) => OrderByBuilderComplex<Usp> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      value:  new OrderByProp(p ? p + "/value" : "value"),
  LocalizedProductHeader_Usp:  p => LocalizedProductHeader_UspOrderBy(p ? p + "/LocalizedProductHeader_Usp" : "LocalizedProductHeader_Usp"),
      UnLocalizedProductHeader_Usp:  p => UnLocalizedProductHeader_UspOrderBy(p ? p + "/UnLocalizedProductHeader_Usp" : "UnLocalizedProductHeader_Usp"),
})

